var map = {
	"./brands/500px.svg": [
		63484,
		63484
	],
	"./brands/accessible-icon.svg": [
		44659,
		44659
	],
	"./brands/accusoft.svg": [
		351,
		351
	],
	"./brands/acquisitions-incorporated.svg": [
		20143,
		20143
	],
	"./brands/adn.svg": [
		19067,
		19067
	],
	"./brands/adversal.svg": [
		41295,
		41295
	],
	"./brands/affiliatetheme.svg": [
		20464,
		20464
	],
	"./brands/airbnb.svg": [
		6103,
		6103
	],
	"./brands/algolia.svg": [
		59577,
		59577
	],
	"./brands/alipay.svg": [
		41732,
		41732
	],
	"./brands/amazon-pay.svg": [
		16283,
		16283
	],
	"./brands/amazon.svg": [
		45445,
		45445
	],
	"./brands/amilia.svg": [
		70745,
		70745
	],
	"./brands/android.svg": [
		13959,
		13959
	],
	"./brands/angellist.svg": [
		21618,
		21618
	],
	"./brands/angrycreative.svg": [
		26088,
		26088
	],
	"./brands/angular.svg": [
		5387,
		5387
	],
	"./brands/app-store-ios.svg": [
		72071,
		72071
	],
	"./brands/app-store.svg": [
		89780,
		89780
	],
	"./brands/apper.svg": [
		19354,
		19354
	],
	"./brands/apple-pay.svg": [
		93181,
		93181
	],
	"./brands/apple.svg": [
		9161,
		9161
	],
	"./brands/artstation.svg": [
		68060,
		68060
	],
	"./brands/asymmetrik.svg": [
		5460,
		5460
	],
	"./brands/atlassian.svg": [
		84382,
		84382
	],
	"./brands/audible.svg": [
		62907,
		62907
	],
	"./brands/autoprefixer.svg": [
		75656,
		75656
	],
	"./brands/avianex.svg": [
		96691,
		96691
	],
	"./brands/aviato.svg": [
		42108,
		42108
	],
	"./brands/aws.svg": [
		30532,
		30532
	],
	"./brands/bandcamp.svg": [
		50014,
		50014
	],
	"./brands/battle-net.svg": [
		3507,
		3507
	],
	"./brands/behance-square.svg": [
		26807,
		26807
	],
	"./brands/behance.svg": [
		18438,
		18438
	],
	"./brands/bimobject.svg": [
		29924,
		29924
	],
	"./brands/bitbucket.svg": [
		2051,
		2051
	],
	"./brands/bitcoin.svg": [
		78374,
		78374
	],
	"./brands/bity.svg": [
		66530,
		66530
	],
	"./brands/black-tie.svg": [
		56922,
		56922
	],
	"./brands/blackberry.svg": [
		98525,
		98525
	],
	"./brands/blogger-b.svg": [
		52545,
		52545
	],
	"./brands/blogger.svg": [
		34397,
		34397
	],
	"./brands/bluetooth-b.svg": [
		39902,
		39902
	],
	"./brands/bluetooth.svg": [
		57419,
		57419
	],
	"./brands/bootstrap.svg": [
		2659,
		2659
	],
	"./brands/btc.svg": [
		56301,
		56301
	],
	"./brands/buffer.svg": [
		52990,
		52990
	],
	"./brands/buromobelexperte.svg": [
		85720,
		85720
	],
	"./brands/buy-n-large.svg": [
		94715,
		94715
	],
	"./brands/buysellads.svg": [
		35613,
		35613
	],
	"./brands/canadian-maple-leaf.svg": [
		84667,
		84667
	],
	"./brands/cc-amazon-pay.svg": [
		52464,
		52464
	],
	"./brands/cc-amex.svg": [
		73597,
		73597
	],
	"./brands/cc-apple-pay.svg": [
		34687,
		34687
	],
	"./brands/cc-diners-club.svg": [
		28257,
		28257
	],
	"./brands/cc-discover.svg": [
		67681,
		67681
	],
	"./brands/cc-jcb.svg": [
		57964,
		57964
	],
	"./brands/cc-mastercard.svg": [
		66909,
		66909
	],
	"./brands/cc-paypal.svg": [
		54623,
		54623
	],
	"./brands/cc-stripe.svg": [
		34200,
		34200
	],
	"./brands/cc-visa.svg": [
		5627,
		5627
	],
	"./brands/centercode.svg": [
		30840,
		30840
	],
	"./brands/centos.svg": [
		3291,
		3291
	],
	"./brands/chrome.svg": [
		51747,
		51747
	],
	"./brands/chromecast.svg": [
		22589,
		22589
	],
	"./brands/cloudflare.svg": [
		32026,
		32026
	],
	"./brands/cloudscale.svg": [
		97936,
		97936
	],
	"./brands/cloudsmith.svg": [
		89790,
		89790
	],
	"./brands/cloudversify.svg": [
		21815,
		21815
	],
	"./brands/codepen.svg": [
		51059,
		51059
	],
	"./brands/codiepie.svg": [
		51894,
		51894
	],
	"./brands/confluence.svg": [
		53558,
		53558
	],
	"./brands/connectdevelop.svg": [
		822,
		822
	],
	"./brands/contao.svg": [
		21860,
		21860
	],
	"./brands/cotton-bureau.svg": [
		22033,
		22033
	],
	"./brands/cpanel.svg": [
		38153,
		38153
	],
	"./brands/creative-commons-by.svg": [
		72742,
		72742
	],
	"./brands/creative-commons-nc-eu.svg": [
		51229,
		51229
	],
	"./brands/creative-commons-nc-jp.svg": [
		22399,
		22399
	],
	"./brands/creative-commons-nc.svg": [
		87936,
		87936
	],
	"./brands/creative-commons-nd.svg": [
		61852,
		61852
	],
	"./brands/creative-commons-pd-alt.svg": [
		72309,
		72309
	],
	"./brands/creative-commons-pd.svg": [
		97073,
		97073
	],
	"./brands/creative-commons-remix.svg": [
		82542,
		82542
	],
	"./brands/creative-commons-sa.svg": [
		86157,
		86157
	],
	"./brands/creative-commons-sampling-plus.svg": [
		5416,
		5416
	],
	"./brands/creative-commons-sampling.svg": [
		53838,
		53838
	],
	"./brands/creative-commons-share.svg": [
		28716,
		28716
	],
	"./brands/creative-commons-zero.svg": [
		21254,
		21254
	],
	"./brands/creative-commons.svg": [
		32269,
		32269
	],
	"./brands/critical-role.svg": [
		56152,
		56152
	],
	"./brands/css3-alt.svg": [
		43395,
		43395
	],
	"./brands/css3.svg": [
		10628,
		10628
	],
	"./brands/cuttlefish.svg": [
		29228,
		29228
	],
	"./brands/d-and-d-beyond.svg": [
		51718,
		51718
	],
	"./brands/d-and-d.svg": [
		68460,
		68460
	],
	"./brands/dailymotion.svg": [
		3044,
		3044
	],
	"./brands/dashcube.svg": [
		95104,
		95104
	],
	"./brands/deezer.svg": [
		52175,
		52175
	],
	"./brands/delicious.svg": [
		87158,
		87158
	],
	"./brands/deploydog.svg": [
		80286,
		80286
	],
	"./brands/deskpro.svg": [
		18528,
		18528
	],
	"./brands/dev.svg": [
		65927,
		65927
	],
	"./brands/deviantart.svg": [
		82116,
		82116
	],
	"./brands/dhl.svg": [
		36113,
		40130
	],
	"./brands/diaspora.svg": [
		27831,
		27831
	],
	"./brands/digg.svg": [
		62757,
		62757
	],
	"./brands/digital-ocean.svg": [
		25370,
		25370
	],
	"./brands/discord.svg": [
		38359,
		38359
	],
	"./brands/discourse.svg": [
		37904,
		37904
	],
	"./brands/dochub.svg": [
		62301,
		62301
	],
	"./brands/docker.svg": [
		52211,
		52211
	],
	"./brands/draft2digital.svg": [
		7897,
		7897
	],
	"./brands/dribbble-square.svg": [
		68447,
		68447
	],
	"./brands/dribbble.svg": [
		6834,
		6834
	],
	"./brands/dropbox.svg": [
		54921,
		54921
	],
	"./brands/drupal.svg": [
		83043,
		83043
	],
	"./brands/dyalog.svg": [
		54388,
		54388
	],
	"./brands/earlybirds.svg": [
		93376,
		93376
	],
	"./brands/ebay.svg": [
		53263,
		53263
	],
	"./brands/edge-legacy.svg": [
		50769,
		50769
	],
	"./brands/edge.svg": [
		80999,
		80999
	],
	"./brands/elementor.svg": [
		42966,
		42966
	],
	"./brands/ello.svg": [
		88393,
		88393
	],
	"./brands/ember.svg": [
		57982,
		57982
	],
	"./brands/empire.svg": [
		41713,
		41713
	],
	"./brands/envira.svg": [
		18373,
		18373
	],
	"./brands/erlang.svg": [
		41080,
		41080
	],
	"./brands/ethereum.svg": [
		92398,
		92398
	],
	"./brands/etsy.svg": [
		68673,
		68673
	],
	"./brands/evernote.svg": [
		81506,
		81506
	],
	"./brands/expeditedssl.svg": [
		87564,
		87564
	],
	"./brands/facebook-f.svg": [
		23478,
		23478
	],
	"./brands/facebook-messenger.svg": [
		21100,
		21100
	],
	"./brands/facebook-square.svg": [
		2204,
		2204
	],
	"./brands/facebook.svg": [
		72341,
		72341
	],
	"./brands/fantasy-flight-games.svg": [
		31658,
		31658
	],
	"./brands/fedex.svg": [
		65537,
		65537
	],
	"./brands/fedora.svg": [
		28699,
		28699
	],
	"./brands/figma.svg": [
		67753,
		67753
	],
	"./brands/firefox-browser.svg": [
		28952,
		28952
	],
	"./brands/firefox.svg": [
		84795,
		84795
	],
	"./brands/first-order-alt.svg": [
		86483,
		86483
	],
	"./brands/first-order.svg": [
		2328,
		2328
	],
	"./brands/firstdraft.svg": [
		76104,
		76104
	],
	"./brands/flickr.svg": [
		50688,
		50688
	],
	"./brands/flipboard.svg": [
		89579,
		89579
	],
	"./brands/fly.svg": [
		20373,
		20373
	],
	"./brands/font-awesome-alt.svg": [
		803,
		803
	],
	"./brands/font-awesome-flag.svg": [
		33093,
		33093
	],
	"./brands/font-awesome-logo-full.svg": [
		25868,
		25868
	],
	"./brands/font-awesome.svg": [
		2241,
		2241
	],
	"./brands/fonticons-fi.svg": [
		15754,
		15754
	],
	"./brands/fonticons.svg": [
		46539,
		46539
	],
	"./brands/fort-awesome-alt.svg": [
		90606,
		90606
	],
	"./brands/fort-awesome.svg": [
		71167,
		71167
	],
	"./brands/forumbee.svg": [
		68071,
		68071
	],
	"./brands/foursquare.svg": [
		74129,
		74129
	],
	"./brands/free-code-camp.svg": [
		69477,
		69477
	],
	"./brands/freebsd.svg": [
		14304,
		81667
	],
	"./brands/fulcrum.svg": [
		50490,
		50490
	],
	"./brands/galactic-republic.svg": [
		73416,
		73416
	],
	"./brands/galactic-senate.svg": [
		70438,
		70438
	],
	"./brands/get-pocket.svg": [
		30227,
		30227
	],
	"./brands/gg-circle.svg": [
		47538,
		47538
	],
	"./brands/gg.svg": [
		98123,
		98123
	],
	"./brands/git-alt.svg": [
		71377,
		71377
	],
	"./brands/git-square.svg": [
		1155,
		1155
	],
	"./brands/git.svg": [
		51795,
		51795
	],
	"./brands/github-alt.svg": [
		60610,
		60610
	],
	"./brands/github-square.svg": [
		84363,
		84363
	],
	"./brands/github.svg": [
		92332,
		92332
	],
	"./brands/gitkraken.svg": [
		21547,
		21547
	],
	"./brands/gitlab.svg": [
		3290,
		3290
	],
	"./brands/gitter.svg": [
		53135,
		53135
	],
	"./brands/glide-g.svg": [
		45393,
		45393
	],
	"./brands/glide.svg": [
		3358,
		3358
	],
	"./brands/gofore.svg": [
		9875,
		9875
	],
	"./brands/goodreads-g.svg": [
		86199,
		86199
	],
	"./brands/goodreads.svg": [
		49259,
		49259
	],
	"./brands/google-drive.svg": [
		41705,
		45697
	],
	"./brands/google-pay.svg": [
		93086,
		93086
	],
	"./brands/google-play.svg": [
		91947,
		91947
	],
	"./brands/google-plus-g.svg": [
		7125,
		7125
	],
	"./brands/google-plus-square.svg": [
		9259,
		9259
	],
	"./brands/google-plus.svg": [
		64643,
		64643
	],
	"./brands/google-wallet.svg": [
		43126,
		43126
	],
	"./brands/google.svg": [
		47845,
		47845
	],
	"./brands/gratipay.svg": [
		4763,
		4763
	],
	"./brands/grav.svg": [
		90335,
		90335
	],
	"./brands/gripfire.svg": [
		81565,
		81565
	],
	"./brands/grunt.svg": [
		40115,
		40115
	],
	"./brands/guilded.svg": [
		41409,
		41409
	],
	"./brands/gulp.svg": [
		42730,
		42730
	],
	"./brands/hacker-news-square.svg": [
		92112,
		92112
	],
	"./brands/hacker-news.svg": [
		32275,
		32275
	],
	"./brands/hackerrank.svg": [
		3989,
		3989
	],
	"./brands/hips.svg": [
		39099,
		39099
	],
	"./brands/hire-a-helper.svg": [
		86509,
		86509
	],
	"./brands/hive.svg": [
		76166,
		76166
	],
	"./brands/hooli.svg": [
		54031,
		54031
	],
	"./brands/hornbill.svg": [
		12113,
		12113
	],
	"./brands/hotjar.svg": [
		22999,
		22999
	],
	"./brands/houzz.svg": [
		99545,
		99545
	],
	"./brands/html5.svg": [
		96523,
		96523
	],
	"./brands/hubspot.svg": [
		690,
		690
	],
	"./brands/ideal.svg": [
		33437,
		33437
	],
	"./brands/imdb.svg": [
		38121,
		38121
	],
	"./brands/innosoft.svg": [
		19391,
		19391
	],
	"./brands/instagram-square.svg": [
		919,
		919
	],
	"./brands/instagram.svg": [
		39777,
		15059
	],
	"./brands/instalod.svg": [
		74464,
		74464
	],
	"./brands/intercom.svg": [
		29561,
		29561
	],
	"./brands/internet-explorer.svg": [
		52364,
		52364
	],
	"./brands/invision.svg": [
		23880,
		23880
	],
	"./brands/ioxhost.svg": [
		62024,
		62024
	],
	"./brands/itch-io.svg": [
		10982,
		10982
	],
	"./brands/itunes-note.svg": [
		62745,
		62745
	],
	"./brands/itunes.svg": [
		47397,
		47397
	],
	"./brands/java.svg": [
		44513,
		44513
	],
	"./brands/jedi-order.svg": [
		17198,
		17198
	],
	"./brands/jenkins.svg": [
		92451,
		92451
	],
	"./brands/jira.svg": [
		10377,
		10377
	],
	"./brands/joget.svg": [
		65790,
		65790
	],
	"./brands/joomla.svg": [
		79327,
		79327
	],
	"./brands/js-square.svg": [
		30360,
		30360
	],
	"./brands/js.svg": [
		4580,
		4580
	],
	"./brands/jsfiddle.svg": [
		35646,
		35646
	],
	"./brands/kaggle.svg": [
		23637,
		23637
	],
	"./brands/keybase.svg": [
		3190,
		3190
	],
	"./brands/keycdn.svg": [
		78192,
		78192
	],
	"./brands/kickstarter-k.svg": [
		70677,
		70677
	],
	"./brands/kickstarter.svg": [
		55949,
		55949
	],
	"./brands/korvue.svg": [
		30774,
		30774
	],
	"./brands/laravel.svg": [
		84539,
		84539
	],
	"./brands/lastfm-square.svg": [
		11033,
		11033
	],
	"./brands/lastfm.svg": [
		90943,
		90943
	],
	"./brands/leanpub.svg": [
		53570,
		53570
	],
	"./brands/less.svg": [
		89448,
		89448
	],
	"./brands/line.svg": [
		65222,
		65222
	],
	"./brands/linkedin-in.svg": [
		66789,
		66789
	],
	"./brands/linkedin.svg": [
		94059,
		94059
	],
	"./brands/linode.svg": [
		57233,
		57233
	],
	"./brands/linux.svg": [
		29555,
		29555
	],
	"./brands/lyft.svg": [
		88905,
		88905
	],
	"./brands/magento.svg": [
		5632,
		5632
	],
	"./brands/mailchimp.svg": [
		46702,
		46702
	],
	"./brands/mandalorian.svg": [
		87578,
		45712
	],
	"./brands/markdown.svg": [
		22762,
		22762
	],
	"./brands/mastodon.svg": [
		10651,
		10651
	],
	"./brands/maxcdn.svg": [
		30377,
		30377
	],
	"./brands/mdb.svg": [
		60652,
		60652
	],
	"./brands/medapps.svg": [
		10679,
		10679
	],
	"./brands/medium-m.svg": [
		85593,
		85593
	],
	"./brands/medium.svg": [
		46943,
		46943
	],
	"./brands/medrt.svg": [
		22407,
		22407
	],
	"./brands/meetup.svg": [
		8292,
		8292
	],
	"./brands/megaport.svg": [
		87336,
		87336
	],
	"./brands/mendeley.svg": [
		54855,
		54855
	],
	"./brands/microblog.svg": [
		28721,
		28721
	],
	"./brands/microsoft.svg": [
		1352,
		1352
	],
	"./brands/mix.svg": [
		80875,
		80875
	],
	"./brands/mixcloud.svg": [
		76826,
		76826
	],
	"./brands/mixer.svg": [
		75206,
		75206
	],
	"./brands/mizuni.svg": [
		78143,
		78143
	],
	"./brands/modx.svg": [
		24179,
		24179
	],
	"./brands/monero.svg": [
		87689,
		87689
	],
	"./brands/napster.svg": [
		49244,
		49244
	],
	"./brands/neos.svg": [
		29338,
		29338
	],
	"./brands/nimblr.svg": [
		51102,
		51102
	],
	"./brands/node-js.svg": [
		26744,
		26744
	],
	"./brands/node.svg": [
		35465,
		35465
	],
	"./brands/npm.svg": [
		33487,
		33487
	],
	"./brands/ns8.svg": [
		39673,
		39673
	],
	"./brands/nutritionix.svg": [
		30453,
		30453
	],
	"./brands/octopus-deploy.svg": [
		63678,
		63678
	],
	"./brands/odnoklassniki-square.svg": [
		1533,
		1533
	],
	"./brands/odnoklassniki.svg": [
		68102,
		68102
	],
	"./brands/old-republic.svg": [
		84813,
		84813
	],
	"./brands/opencart.svg": [
		49814,
		49814
	],
	"./brands/openid.svg": [
		84565,
		84565
	],
	"./brands/opera.svg": [
		7710,
		7710
	],
	"./brands/optin-monster.svg": [
		46035,
		46035
	],
	"./brands/orcid.svg": [
		15038,
		15038
	],
	"./brands/osi.svg": [
		77325,
		77325
	],
	"./brands/page4.svg": [
		55115,
		55115
	],
	"./brands/pagelines.svg": [
		4556,
		4556
	],
	"./brands/palfed.svg": [
		75060,
		75060
	],
	"./brands/patreon.svg": [
		48997,
		48997
	],
	"./brands/paypal.svg": [
		922,
		922
	],
	"./brands/penny-arcade.svg": [
		27279,
		27279
	],
	"./brands/perbyte.svg": [
		56676,
		56676
	],
	"./brands/periscope.svg": [
		51899,
		51899
	],
	"./brands/phabricator.svg": [
		21800,
		21800
	],
	"./brands/phoenix-framework.svg": [
		84094,
		84094
	],
	"./brands/phoenix-squadron.svg": [
		22414,
		22414
	],
	"./brands/php.svg": [
		81594,
		81594
	],
	"./brands/pied-piper-alt.svg": [
		79285,
		79285
	],
	"./brands/pied-piper-hat.svg": [
		94888,
		94888
	],
	"./brands/pied-piper-pp.svg": [
		16888,
		16888
	],
	"./brands/pied-piper-square.svg": [
		24578,
		24578
	],
	"./brands/pied-piper.svg": [
		84212,
		84212
	],
	"./brands/pinterest-p.svg": [
		91189,
		91189
	],
	"./brands/pinterest-square.svg": [
		33339,
		33339
	],
	"./brands/pinterest.svg": [
		53289,
		53289
	],
	"./brands/playstation.svg": [
		74469,
		74469
	],
	"./brands/product-hunt.svg": [
		44161,
		44161
	],
	"./brands/pushed.svg": [
		75045,
		75045
	],
	"./brands/python.svg": [
		86324,
		86324
	],
	"./brands/qq.svg": [
		40727,
		40727
	],
	"./brands/quinscape.svg": [
		58100,
		58100
	],
	"./brands/quora.svg": [
		44742,
		44742
	],
	"./brands/r-project.svg": [
		30915,
		30915
	],
	"./brands/raspberry-pi.svg": [
		18053,
		18053
	],
	"./brands/ravelry.svg": [
		69925,
		69925
	],
	"./brands/react.svg": [
		64,
		64
	],
	"./brands/reacteurope.svg": [
		82862,
		82862
	],
	"./brands/readme.svg": [
		72075,
		72075
	],
	"./brands/rebel.svg": [
		41839,
		41839
	],
	"./brands/red-river.svg": [
		32200,
		32200
	],
	"./brands/reddit-alien.svg": [
		89615,
		89615
	],
	"./brands/reddit-square.svg": [
		17549,
		17549
	],
	"./brands/reddit.svg": [
		10732,
		10732
	],
	"./brands/redhat.svg": [
		2909,
		2909
	],
	"./brands/renren.svg": [
		33432,
		33432
	],
	"./brands/replyd.svg": [
		8709,
		8709
	],
	"./brands/researchgate.svg": [
		49444,
		49444
	],
	"./brands/resolving.svg": [
		64922,
		64922
	],
	"./brands/rev.svg": [
		9845,
		9845
	],
	"./brands/rocketchat.svg": [
		68962,
		68962
	],
	"./brands/rockrms.svg": [
		12909,
		12909
	],
	"./brands/rust.svg": [
		71072,
		71072
	],
	"./brands/safari.svg": [
		7722,
		7722
	],
	"./brands/salesforce.svg": [
		97644,
		97644
	],
	"./brands/sass.svg": [
		21994,
		21994
	],
	"./brands/schlix.svg": [
		88310,
		88310
	],
	"./brands/scribd.svg": [
		9922,
		9922
	],
	"./brands/searchengin.svg": [
		42699,
		42699
	],
	"./brands/sellcast.svg": [
		61171,
		61171
	],
	"./brands/sellsy.svg": [
		27839,
		27839
	],
	"./brands/servicestack.svg": [
		42596,
		42596
	],
	"./brands/shirtsinbulk.svg": [
		97521,
		97521
	],
	"./brands/shopify.svg": [
		97191,
		97191
	],
	"./brands/shopware.svg": [
		5118,
		5118
	],
	"./brands/simplybuilt.svg": [
		36078,
		36078
	],
	"./brands/sistrix.svg": [
		52043,
		52043
	],
	"./brands/sith.svg": [
		42811,
		42811
	],
	"./brands/sketch.svg": [
		51202,
		51202
	],
	"./brands/skyatlas.svg": [
		32179,
		32179
	],
	"./brands/skype.svg": [
		66053,
		66053
	],
	"./brands/slack-hash.svg": [
		57029,
		57029
	],
	"./brands/slack.svg": [
		40334,
		40334
	],
	"./brands/slideshare.svg": [
		66113,
		66113
	],
	"./brands/snapchat-ghost.svg": [
		14392,
		14392
	],
	"./brands/snapchat-square.svg": [
		21999,
		21999
	],
	"./brands/snapchat.svg": [
		97555,
		97555
	],
	"./brands/soundcloud.svg": [
		91030,
		91030
	],
	"./brands/sourcetree.svg": [
		79217,
		79217
	],
	"./brands/speakap.svg": [
		46330,
		46330
	],
	"./brands/speaker-deck.svg": [
		96593,
		96593
	],
	"./brands/spotify.svg": [
		3111,
		3111
	],
	"./brands/squarespace.svg": [
		30498,
		30498
	],
	"./brands/stack-exchange.svg": [
		28858,
		28858
	],
	"./brands/stack-overflow.svg": [
		75202,
		75202
	],
	"./brands/stackpath.svg": [
		64115,
		64115
	],
	"./brands/staylinked.svg": [
		63760,
		63760
	],
	"./brands/steam-square.svg": [
		260,
		260
	],
	"./brands/steam-symbol.svg": [
		47937,
		47937
	],
	"./brands/steam.svg": [
		81805,
		81805
	],
	"./brands/sticker-mule.svg": [
		90113,
		90113
	],
	"./brands/strava.svg": [
		81241,
		81241
	],
	"./brands/stripe-s.svg": [
		84871,
		84871
	],
	"./brands/stripe.svg": [
		70824,
		70824
	],
	"./brands/studiovinari.svg": [
		44713,
		44713
	],
	"./brands/stumbleupon-circle.svg": [
		22614,
		22614
	],
	"./brands/stumbleupon.svg": [
		17063,
		17063
	],
	"./brands/superpowers.svg": [
		14686,
		14686
	],
	"./brands/supple.svg": [
		96502,
		96502
	],
	"./brands/suse.svg": [
		734,
		734
	],
	"./brands/swift.svg": [
		27453,
		27453
	],
	"./brands/symfony.svg": [
		89109,
		89109
	],
	"./brands/teamspeak.svg": [
		25394,
		25394
	],
	"./brands/telegram-plane.svg": [
		62108,
		62108
	],
	"./brands/telegram.svg": [
		11327,
		11327
	],
	"./brands/tencent-weibo.svg": [
		42594,
		42594
	],
	"./brands/the-red-yeti.svg": [
		17104,
		17104
	],
	"./brands/themeco.svg": [
		97229,
		97229
	],
	"./brands/themeisle.svg": [
		61279,
		61279
	],
	"./brands/think-peaks.svg": [
		29870,
		29870
	],
	"./brands/tiktok.svg": [
		81825,
		81825
	],
	"./brands/trade-federation.svg": [
		64152,
		64152
	],
	"./brands/trello.svg": [
		16682,
		16682
	],
	"./brands/tumblr-square.svg": [
		18214,
		18214
	],
	"./brands/tumblr.svg": [
		36677,
		36677
	],
	"./brands/twitch.svg": [
		7832,
		7832
	],
	"./brands/twitter-square.svg": [
		58912,
		58912
	],
	"./brands/twitter.svg": [
		10975,
		10975
	],
	"./brands/typo3.svg": [
		33878,
		33878
	],
	"./brands/uber.svg": [
		83675,
		83675
	],
	"./brands/ubuntu.svg": [
		12414,
		12414
	],
	"./brands/uikit.svg": [
		72192,
		72192
	],
	"./brands/umbraco.svg": [
		52661,
		52661
	],
	"./brands/uncharted.svg": [
		53182,
		53182
	],
	"./brands/uniregistry.svg": [
		85468,
		85468
	],
	"./brands/unity.svg": [
		81016,
		81016
	],
	"./brands/unsplash.svg": [
		78228,
		78228
	],
	"./brands/untappd.svg": [
		155,
		155
	],
	"./brands/ups.svg": [
		28769,
		28769
	],
	"./brands/usb.svg": [
		44791,
		44791
	],
	"./brands/usps.svg": [
		50374,
		50374
	],
	"./brands/ussunnah.svg": [
		23177,
		23177
	],
	"./brands/vaadin.svg": [
		82988,
		82988
	],
	"./brands/viacoin.svg": [
		2196,
		2196
	],
	"./brands/viadeo-square.svg": [
		82745,
		82745
	],
	"./brands/viadeo.svg": [
		94956,
		94956
	],
	"./brands/viber.svg": [
		97024,
		97024
	],
	"./brands/vimeo-square.svg": [
		13402,
		13402
	],
	"./brands/vimeo-v.svg": [
		32072,
		32072
	],
	"./brands/vimeo.svg": [
		60453,
		60453
	],
	"./brands/vine.svg": [
		10010,
		10010
	],
	"./brands/vk.svg": [
		211,
		211
	],
	"./brands/vnv.svg": [
		19075,
		19075
	],
	"./brands/vuejs.svg": [
		6373,
		6373
	],
	"./brands/watchman-monitoring.svg": [
		13042,
		13042
	],
	"./brands/waze.svg": [
		38252,
		38252
	],
	"./brands/weebly.svg": [
		50832,
		50832
	],
	"./brands/weibo.svg": [
		43381,
		43381
	],
	"./brands/weixin.svg": [
		27741,
		27741
	],
	"./brands/whatsapp-square.svg": [
		36664,
		36664
	],
	"./brands/whatsapp.svg": [
		59587,
		59587
	],
	"./brands/whmcs.svg": [
		87887,
		87887
	],
	"./brands/wikipedia-w.svg": [
		98460,
		98460
	],
	"./brands/windows.svg": [
		721,
		721
	],
	"./brands/wix.svg": [
		90267,
		90267
	],
	"./brands/wizards-of-the-coast.svg": [
		71717,
		71717
	],
	"./brands/wodu.svg": [
		98063,
		98063
	],
	"./brands/wolf-pack-battalion.svg": [
		91840,
		91840
	],
	"./brands/wordpress-simple.svg": [
		79671,
		79671
	],
	"./brands/wordpress.svg": [
		72085,
		72085
	],
	"./brands/wpbeginner.svg": [
		42667,
		42667
	],
	"./brands/wpexplorer.svg": [
		87515,
		87515
	],
	"./brands/wpforms.svg": [
		63962,
		63962
	],
	"./brands/wpressr.svg": [
		20718,
		20718
	],
	"./brands/xbox.svg": [
		16526,
		16526
	],
	"./brands/xing-square.svg": [
		52595,
		52595
	],
	"./brands/xing.svg": [
		76369,
		76369
	],
	"./brands/y-combinator.svg": [
		81210,
		81210
	],
	"./brands/yahoo.svg": [
		10681,
		10681
	],
	"./brands/yammer.svg": [
		11740,
		11740
	],
	"./brands/yandex-international.svg": [
		15422,
		15422
	],
	"./brands/yandex.svg": [
		96763,
		96763
	],
	"./brands/yarn.svg": [
		17770,
		17770
	],
	"./brands/yelp.svg": [
		95773,
		95773
	],
	"./brands/yoast.svg": [
		33109,
		33109
	],
	"./brands/youtube-square.svg": [
		97461,
		97461
	],
	"./brands/youtube.svg": [
		85344,
		19130
	],
	"./brands/zhihu.svg": [
		21062,
		21062
	],
	"./regular/address-book.svg": [
		39105,
		39105
	],
	"./regular/address-card.svg": [
		41262,
		41262
	],
	"./regular/angry.svg": [
		76577,
		76577
	],
	"./regular/arrow-alt-circle-down.svg": [
		54873,
		54873
	],
	"./regular/arrow-alt-circle-left.svg": [
		8964,
		8964
	],
	"./regular/arrow-alt-circle-right.svg": [
		34318,
		34318
	],
	"./regular/arrow-alt-circle-up.svg": [
		63646,
		63646
	],
	"./regular/bell-slash.svg": [
		10609,
		10609
	],
	"./regular/bell.svg": [
		58891,
		58891
	],
	"./regular/bookmark.svg": [
		95856,
		95856
	],
	"./regular/building.svg": [
		81053,
		81053
	],
	"./regular/calendar-alt.svg": [
		87145,
		87145
	],
	"./regular/calendar-check.svg": [
		82334,
		82334
	],
	"./regular/calendar-minus.svg": [
		60184,
		60184
	],
	"./regular/calendar-plus.svg": [
		8717,
		8717
	],
	"./regular/calendar-times.svg": [
		50448,
		50448
	],
	"./regular/calendar.svg": [
		76213,
		76213
	],
	"./regular/caret-square-down.svg": [
		97122,
		97122
	],
	"./regular/caret-square-left.svg": [
		42591,
		42591
	],
	"./regular/caret-square-right.svg": [
		3438,
		3438
	],
	"./regular/caret-square-up.svg": [
		17991,
		17991
	],
	"./regular/chart-bar.svg": [
		64555,
		64555
	],
	"./regular/check-circle.svg": [
		7991,
		7991
	],
	"./regular/check-square.svg": [
		69088,
		69088
	],
	"./regular/circle.svg": [
		67964,
		67964
	],
	"./regular/clipboard.svg": [
		60713,
		60713
	],
	"./regular/clock.svg": [
		48811,
		48811
	],
	"./regular/clone.svg": [
		64470,
		64470
	],
	"./regular/closed-captioning.svg": [
		56166,
		56166
	],
	"./regular/comment-alt.svg": [
		3416,
		3416
	],
	"./regular/comment-dots.svg": [
		82897,
		82897
	],
	"./regular/comment.svg": [
		33324,
		33324
	],
	"./regular/comments.svg": [
		93231,
		93231
	],
	"./regular/compass.svg": [
		34791,
		34791
	],
	"./regular/copy.svg": [
		80980,
		80980
	],
	"./regular/copyright.svg": [
		48409,
		48409
	],
	"./regular/credit-card.svg": [
		86301,
		86301
	],
	"./regular/dizzy.svg": [
		33834,
		33834
	],
	"./regular/dot-circle.svg": [
		34146,
		34146
	],
	"./regular/edit.svg": [
		19195,
		19195
	],
	"./regular/envelope-open.svg": [
		1612,
		1612
	],
	"./regular/envelope.svg": [
		6668,
		6668
	],
	"./regular/eye-slash.svg": [
		48441,
		48441
	],
	"./regular/eye.svg": [
		8196,
		8196
	],
	"./regular/file-alt.svg": [
		6222,
		6222
	],
	"./regular/file-archive.svg": [
		32099,
		32099
	],
	"./regular/file-audio.svg": [
		49335,
		49335
	],
	"./regular/file-code.svg": [
		23418,
		23418
	],
	"./regular/file-excel.svg": [
		50025,
		50025
	],
	"./regular/file-image.svg": [
		12040,
		12040
	],
	"./regular/file-pdf.svg": [
		44242,
		44242
	],
	"./regular/file-powerpoint.svg": [
		71446,
		71446
	],
	"./regular/file-video.svg": [
		46461,
		46461
	],
	"./regular/file-word.svg": [
		95363,
		95363
	],
	"./regular/file.svg": [
		83804,
		83804
	],
	"./regular/flag.svg": [
		78039,
		78039
	],
	"./regular/flushed.svg": [
		39812,
		39812
	],
	"./regular/folder-open.svg": [
		15540,
		15540
	],
	"./regular/folder.svg": [
		56608,
		56608
	],
	"./regular/font-awesome-logo-full.svg": [
		73306,
		73306
	],
	"./regular/frown-open.svg": [
		47420,
		47420
	],
	"./regular/frown.svg": [
		89355,
		89355
	],
	"./regular/futbol.svg": [
		63674,
		63674
	],
	"./regular/gem.svg": [
		205,
		205
	],
	"./regular/grimace.svg": [
		40904,
		40904
	],
	"./regular/grin-alt.svg": [
		87458,
		87458
	],
	"./regular/grin-beam-sweat.svg": [
		19117,
		19117
	],
	"./regular/grin-beam.svg": [
		81333,
		81333
	],
	"./regular/grin-hearts.svg": [
		53494,
		53494
	],
	"./regular/grin-squint-tears.svg": [
		54810,
		54810
	],
	"./regular/grin-squint.svg": [
		95526,
		95526
	],
	"./regular/grin-stars.svg": [
		32520,
		32520
	],
	"./regular/grin-tears.svg": [
		45082,
		45082
	],
	"./regular/grin-tongue-squint.svg": [
		34228,
		34228
	],
	"./regular/grin-tongue-wink.svg": [
		63767,
		63767
	],
	"./regular/grin-tongue.svg": [
		57876,
		57876
	],
	"./regular/grin-wink.svg": [
		44170,
		44170
	],
	"./regular/grin.svg": [
		60977,
		60977
	],
	"./regular/hand-lizard.svg": [
		66466,
		66466
	],
	"./regular/hand-paper.svg": [
		68790,
		68790
	],
	"./regular/hand-peace.svg": [
		57114,
		57114
	],
	"./regular/hand-point-down.svg": [
		11407,
		11407
	],
	"./regular/hand-point-left.svg": [
		81618,
		81618
	],
	"./regular/hand-point-right.svg": [
		16800,
		16800
	],
	"./regular/hand-point-up.svg": [
		15966,
		15966
	],
	"./regular/hand-pointer.svg": [
		12424,
		12424
	],
	"./regular/hand-rock.svg": [
		21683,
		21683
	],
	"./regular/hand-scissors.svg": [
		2299,
		2299
	],
	"./regular/hand-spock.svg": [
		3944,
		3944
	],
	"./regular/handshake.svg": [
		29151,
		29151
	],
	"./regular/hdd.svg": [
		47377,
		47377
	],
	"./regular/heart.svg": [
		70389,
		70389
	],
	"./regular/hospital.svg": [
		45427,
		45427
	],
	"./regular/hourglass.svg": [
		41813,
		41813
	],
	"./regular/id-badge.svg": [
		77684,
		77684
	],
	"./regular/id-card.svg": [
		55330,
		55330
	],
	"./regular/image.svg": [
		79191,
		79191
	],
	"./regular/images.svg": [
		32714,
		32714
	],
	"./regular/keyboard.svg": [
		88482,
		88482
	],
	"./regular/kiss-beam.svg": [
		70022,
		70022
	],
	"./regular/kiss-wink-heart.svg": [
		18439,
		18439
	],
	"./regular/kiss.svg": [
		5214,
		5214
	],
	"./regular/laugh-beam.svg": [
		87557,
		87557
	],
	"./regular/laugh-squint.svg": [
		49346,
		49346
	],
	"./regular/laugh-wink.svg": [
		87490,
		87490
	],
	"./regular/laugh.svg": [
		60737,
		60737
	],
	"./regular/lemon.svg": [
		21339,
		21339
	],
	"./regular/life-ring.svg": [
		1193,
		1193
	],
	"./regular/lightbulb.svg": [
		54558,
		54558
	],
	"./regular/list-alt.svg": [
		5218,
		26728
	],
	"./regular/map.svg": [
		6818,
		6818
	],
	"./regular/meh-blank.svg": [
		1872,
		1872
	],
	"./regular/meh-rolling-eyes.svg": [
		45354,
		45354
	],
	"./regular/meh.svg": [
		59962,
		59962
	],
	"./regular/minus-square.svg": [
		97497,
		97497
	],
	"./regular/money-bill-alt.svg": [
		88204,
		88204
	],
	"./regular/moon.svg": [
		85712,
		85712
	],
	"./regular/newspaper.svg": [
		18457,
		18457
	],
	"./regular/object-group.svg": [
		47008,
		47008
	],
	"./regular/object-ungroup.svg": [
		36322,
		36322
	],
	"./regular/paper-plane.svg": [
		62789,
		62789
	],
	"./regular/pause-circle.svg": [
		5226,
		5226
	],
	"./regular/play-circle.svg": [
		82097,
		82097
	],
	"./regular/plus-square.svg": [
		26490,
		26490
	],
	"./regular/question-circle.svg": [
		92730,
		92730
	],
	"./regular/registered.svg": [
		63506,
		46871
	],
	"./regular/sad-cry.svg": [
		45355,
		45355
	],
	"./regular/sad-tear.svg": [
		50,
		50
	],
	"./regular/save.svg": [
		73829,
		73829
	],
	"./regular/share-square.svg": [
		87932,
		87932
	],
	"./regular/smile-beam.svg": [
		51139,
		40258
	],
	"./regular/smile-wink.svg": [
		23442,
		23442
	],
	"./regular/smile.svg": [
		69845,
		69845
	],
	"./regular/snowflake.svg": [
		51762,
		51762
	],
	"./regular/square.svg": [
		48733,
		48733
	],
	"./regular/star-half.svg": [
		22718,
		22718
	],
	"./regular/star.svg": [
		77890,
		77890
	],
	"./regular/sticky-note.svg": [
		98260,
		70577
	],
	"./regular/stop-circle.svg": [
		35266,
		35266
	],
	"./regular/sun.svg": [
		43475,
		43475
	],
	"./regular/surprise.svg": [
		44948,
		44948
	],
	"./regular/thumbs-down.svg": [
		69947,
		69947
	],
	"./regular/thumbs-up.svg": [
		5351,
		5351
	],
	"./regular/times-circle.svg": [
		42837,
		42837
	],
	"./regular/tired.svg": [
		98146,
		98146
	],
	"./regular/trash-alt.svg": [
		53370,
		53370
	],
	"./regular/user-circle.svg": [
		16459,
		16459
	],
	"./regular/user.svg": [
		14033,
		14033
	],
	"./regular/window-close.svg": [
		97283,
		97283
	],
	"./regular/window-maximize.svg": [
		61912,
		61912
	],
	"./regular/window-minimize.svg": [
		80092,
		80092
	],
	"./regular/window-restore.svg": [
		49321,
		49321
	],
	"./solid/ad.svg": [
		75434,
		75434
	],
	"./solid/address-book.svg": [
		87688,
		87688
	],
	"./solid/address-card.svg": [
		87511,
		87511
	],
	"./solid/adjust.svg": [
		76057,
		76057
	],
	"./solid/air-freshener.svg": [
		82252,
		82252
	],
	"./solid/align-center.svg": [
		64875,
		64875
	],
	"./solid/align-justify.svg": [
		18106,
		18106
	],
	"./solid/align-left.svg": [
		51051,
		51051
	],
	"./solid/align-right.svg": [
		53846,
		53846
	],
	"./solid/allergies.svg": [
		82814,
		82814
	],
	"./solid/ambulance.svg": [
		12840,
		12840
	],
	"./solid/american-sign-language-interpreting.svg": [
		67968,
		67968
	],
	"./solid/anchor.svg": [
		59834,
		59834
	],
	"./solid/angle-double-down.svg": [
		92100,
		92100
	],
	"./solid/angle-double-left.svg": [
		90856,
		90856
	],
	"./solid/angle-double-right.svg": [
		9141,
		9141
	],
	"./solid/angle-double-up.svg": [
		46547,
		46547
	],
	"./solid/angle-down.svg": [
		65645,
		65645
	],
	"./solid/angle-left.svg": [
		52665,
		52665
	],
	"./solid/angle-right.svg": [
		58251,
		58251
	],
	"./solid/angle-up.svg": [
		86256,
		86256
	],
	"./solid/angry.svg": [
		90487,
		90487
	],
	"./solid/ankh.svg": [
		53386,
		53386
	],
	"./solid/apple-alt.svg": [
		3491,
		3491
	],
	"./solid/archive.svg": [
		83911,
		83911
	],
	"./solid/archway.svg": [
		29547,
		29547
	],
	"./solid/arrow-alt-circle-down.svg": [
		45415,
		45415
	],
	"./solid/arrow-alt-circle-left.svg": [
		5702,
		5702
	],
	"./solid/arrow-alt-circle-right.svg": [
		5870,
		5870
	],
	"./solid/arrow-alt-circle-up.svg": [
		38915,
		38915
	],
	"./solid/arrow-circle-down.svg": [
		30803,
		30803
	],
	"./solid/arrow-circle-left.svg": [
		3344,
		3344
	],
	"./solid/arrow-circle-right.svg": [
		21550,
		21550
	],
	"./solid/arrow-circle-up.svg": [
		78759,
		78759
	],
	"./solid/arrow-down.svg": [
		46247,
		46247
	],
	"./solid/arrow-left.svg": [
		62268,
		62268
	],
	"./solid/arrow-right.svg": [
		49572,
		49572
	],
	"./solid/arrow-up.svg": [
		90041,
		90041
	],
	"./solid/arrows-alt-h.svg": [
		8027,
		8027
	],
	"./solid/arrows-alt-v.svg": [
		86280,
		86280
	],
	"./solid/arrows-alt.svg": [
		18940,
		18940
	],
	"./solid/assistive-listening-systems.svg": [
		8135,
		8135
	],
	"./solid/asterisk.svg": [
		23365,
		23365
	],
	"./solid/at.svg": [
		66834,
		66834
	],
	"./solid/atlas.svg": [
		24135,
		24135
	],
	"./solid/atom.svg": [
		91506,
		91506
	],
	"./solid/audio-description.svg": [
		98670,
		98670
	],
	"./solid/award.svg": [
		51314,
		51314
	],
	"./solid/baby-carriage.svg": [
		99612,
		99612
	],
	"./solid/baby.svg": [
		68834,
		68834
	],
	"./solid/backspace.svg": [
		56537,
		56537
	],
	"./solid/backward.svg": [
		25276,
		25276
	],
	"./solid/bacon.svg": [
		39818,
		39818
	],
	"./solid/bacteria.svg": [
		68975,
		68975
	],
	"./solid/bacterium.svg": [
		44962,
		44962
	],
	"./solid/bahai.svg": [
		1153,
		1153
	],
	"./solid/balance-scale-left.svg": [
		96223,
		96223
	],
	"./solid/balance-scale-right.svg": [
		28366,
		28366
	],
	"./solid/balance-scale.svg": [
		43900,
		43900
	],
	"./solid/ban.svg": [
		13979,
		13979
	],
	"./solid/band-aid.svg": [
		82712,
		82712
	],
	"./solid/barcode.svg": [
		78613,
		78613
	],
	"./solid/bars.svg": [
		19210,
		19210
	],
	"./solid/baseball-ball.svg": [
		43930,
		43930
	],
	"./solid/basketball-ball.svg": [
		28286,
		28286
	],
	"./solid/bath.svg": [
		24966,
		24966
	],
	"./solid/battery-empty.svg": [
		77130,
		77130
	],
	"./solid/battery-full.svg": [
		88592,
		88592
	],
	"./solid/battery-half.svg": [
		53226,
		53226
	],
	"./solid/battery-quarter.svg": [
		45513,
		45513
	],
	"./solid/battery-three-quarters.svg": [
		96916,
		96916
	],
	"./solid/bed.svg": [
		8309,
		8309
	],
	"./solid/beer.svg": [
		69804,
		69804
	],
	"./solid/bell-slash.svg": [
		96235,
		96235
	],
	"./solid/bell.svg": [
		29271,
		29271
	],
	"./solid/bezier-curve.svg": [
		78969,
		78969
	],
	"./solid/bible.svg": [
		7781,
		7781
	],
	"./solid/bicycle.svg": [
		6594,
		6594
	],
	"./solid/biking.svg": [
		82982,
		82982
	],
	"./solid/binoculars.svg": [
		24840,
		24840
	],
	"./solid/biohazard.svg": [
		44325,
		44325
	],
	"./solid/birthday-cake.svg": [
		11903,
		11903
	],
	"./solid/blender-phone.svg": [
		47075,
		47075
	],
	"./solid/blender.svg": [
		99725,
		99725
	],
	"./solid/blind.svg": [
		91147,
		91147
	],
	"./solid/blog.svg": [
		63922,
		63922
	],
	"./solid/bold.svg": [
		42736,
		42736
	],
	"./solid/bolt.svg": [
		31840,
		31840
	],
	"./solid/bomb.svg": [
		12703,
		12703
	],
	"./solid/bone.svg": [
		98741,
		98741
	],
	"./solid/bong.svg": [
		11123,
		18834
	],
	"./solid/book-dead.svg": [
		37004,
		37004
	],
	"./solid/book-medical.svg": [
		97893,
		97893
	],
	"./solid/book-open.svg": [
		41497,
		41497
	],
	"./solid/book-reader.svg": [
		93758,
		93758
	],
	"./solid/book.svg": [
		17311,
		17311
	],
	"./solid/bookmark.svg": [
		82322,
		82322
	],
	"./solid/border-all.svg": [
		17019,
		17019
	],
	"./solid/border-none.svg": [
		81941,
		81941
	],
	"./solid/border-style.svg": [
		32149,
		32149
	],
	"./solid/bowling-ball.svg": [
		29325,
		29325
	],
	"./solid/box-open.svg": [
		86188,
		86188
	],
	"./solid/box-tissue.svg": [
		9301,
		9301
	],
	"./solid/box.svg": [
		72518,
		72518
	],
	"./solid/boxes.svg": [
		81214,
		81214
	],
	"./solid/braille.svg": [
		34938,
		34938
	],
	"./solid/brain.svg": [
		76397,
		76397
	],
	"./solid/bread-slice.svg": [
		89968,
		89968
	],
	"./solid/briefcase-medical.svg": [
		47263,
		47263
	],
	"./solid/briefcase.svg": [
		38578,
		38578
	],
	"./solid/broadcast-tower.svg": [
		69908,
		69908
	],
	"./solid/broom.svg": [
		88509,
		88509
	],
	"./solid/brush.svg": [
		54717,
		54717
	],
	"./solid/bug.svg": [
		9890,
		9890
	],
	"./solid/building.svg": [
		50651,
		50651
	],
	"./solid/bullhorn.svg": [
		74899,
		74899
	],
	"./solid/bullseye.svg": [
		8455,
		8455
	],
	"./solid/burn.svg": [
		65636,
		65636
	],
	"./solid/bus-alt.svg": [
		36087,
		36087
	],
	"./solid/bus.svg": [
		49933,
		49933
	],
	"./solid/business-time.svg": [
		62650,
		62650
	],
	"./solid/calculator.svg": [
		79210,
		79210
	],
	"./solid/calendar-alt.svg": [
		40948,
		40948
	],
	"./solid/calendar-check.svg": [
		60990,
		60990
	],
	"./solid/calendar-day.svg": [
		23183,
		23183
	],
	"./solid/calendar-minus.svg": [
		47163,
		47163
	],
	"./solid/calendar-plus.svg": [
		1668,
		1668
	],
	"./solid/calendar-times.svg": [
		47680,
		47680
	],
	"./solid/calendar-week.svg": [
		78768,
		78768
	],
	"./solid/calendar.svg": [
		58442,
		58442
	],
	"./solid/camera-retro.svg": [
		50065,
		50065
	],
	"./solid/camera.svg": [
		43387,
		43387
	],
	"./solid/campground.svg": [
		82538,
		82538
	],
	"./solid/candy-cane.svg": [
		70837,
		70837
	],
	"./solid/cannabis.svg": [
		11047,
		11047
	],
	"./solid/capsules.svg": [
		55628,
		55628
	],
	"./solid/car-alt.svg": [
		25003,
		25003
	],
	"./solid/car-battery.svg": [
		44759,
		44759
	],
	"./solid/car-crash.svg": [
		45435,
		45435
	],
	"./solid/car-side.svg": [
		94909,
		94909
	],
	"./solid/car.svg": [
		20733,
		20733
	],
	"./solid/caravan.svg": [
		46429,
		46429
	],
	"./solid/caret-down.svg": [
		6068,
		58299
	],
	"./solid/caret-left.svg": [
		54626,
		54626
	],
	"./solid/caret-right.svg": [
		41823,
		41823
	],
	"./solid/caret-square-down.svg": [
		43587,
		43587
	],
	"./solid/caret-square-left.svg": [
		56235,
		56235
	],
	"./solid/caret-square-right.svg": [
		80546,
		80546
	],
	"./solid/caret-square-up.svg": [
		21096,
		21096
	],
	"./solid/caret-up.svg": [
		31475,
		31475
	],
	"./solid/carrot.svg": [
		90838,
		90838
	],
	"./solid/cart-arrow-down.svg": [
		1451,
		1451
	],
	"./solid/cart-plus.svg": [
		34476,
		34476
	],
	"./solid/cash-register.svg": [
		58809,
		58809
	],
	"./solid/cat.svg": [
		61442,
		61442
	],
	"./solid/certificate.svg": [
		33369,
		33369
	],
	"./solid/chair.svg": [
		38539,
		38539
	],
	"./solid/chalkboard-teacher.svg": [
		47228,
		47228
	],
	"./solid/chalkboard.svg": [
		77496,
		77496
	],
	"./solid/charging-station.svg": [
		26924,
		26924
	],
	"./solid/chart-area.svg": [
		75393,
		75393
	],
	"./solid/chart-bar.svg": [
		69432,
		69432
	],
	"./solid/chart-line.svg": [
		41540,
		41540
	],
	"./solid/chart-pie.svg": [
		48479,
		48479
	],
	"./solid/check-circle.svg": [
		26422,
		26422
	],
	"./solid/check-double.svg": [
		11193,
		11193
	],
	"./solid/check-square.svg": [
		28300,
		28300
	],
	"./solid/check.svg": [
		98176,
		98176
	],
	"./solid/cheese.svg": [
		30193,
		30193
	],
	"./solid/chess-bishop.svg": [
		81265,
		81265
	],
	"./solid/chess-board.svg": [
		47756,
		47756
	],
	"./solid/chess-king.svg": [
		64375,
		64375
	],
	"./solid/chess-knight.svg": [
		19832,
		19832
	],
	"./solid/chess-pawn.svg": [
		52590,
		52590
	],
	"./solid/chess-queen.svg": [
		19006,
		19006
	],
	"./solid/chess-rook.svg": [
		35412,
		35412
	],
	"./solid/chess.svg": [
		9627,
		9627
	],
	"./solid/chevron-circle-down.svg": [
		20285,
		20285
	],
	"./solid/chevron-circle-left.svg": [
		64738,
		64738
	],
	"./solid/chevron-circle-right.svg": [
		31713,
		31713
	],
	"./solid/chevron-circle-up.svg": [
		28050,
		28050
	],
	"./solid/chevron-down.svg": [
		77262,
		77262
	],
	"./solid/chevron-left.svg": [
		65239,
		65239
	],
	"./solid/chevron-right.svg": [
		964,
		964
	],
	"./solid/chevron-up.svg": [
		7318,
		7318
	],
	"./solid/child.svg": [
		42479,
		42479
	],
	"./solid/church.svg": [
		58324,
		58324
	],
	"./solid/circle-notch.svg": [
		54805,
		54805
	],
	"./solid/circle.svg": [
		67364,
		67364
	],
	"./solid/city.svg": [
		47106,
		47106
	],
	"./solid/clinic-medical.svg": [
		72102,
		72102
	],
	"./solid/clipboard-check.svg": [
		68657,
		68657
	],
	"./solid/clipboard-list.svg": [
		30700,
		30700
	],
	"./solid/clipboard.svg": [
		69562,
		69562
	],
	"./solid/clock.svg": [
		47533,
		47533
	],
	"./solid/clone.svg": [
		79863,
		79863
	],
	"./solid/closed-captioning.svg": [
		82855,
		82855
	],
	"./solid/cloud-download-alt.svg": [
		25855,
		25855
	],
	"./solid/cloud-meatball.svg": [
		61560,
		61560
	],
	"./solid/cloud-moon-rain.svg": [
		61865,
		61865
	],
	"./solid/cloud-moon.svg": [
		12553,
		12553
	],
	"./solid/cloud-rain.svg": [
		53769,
		53769
	],
	"./solid/cloud-showers-heavy.svg": [
		67398,
		67398
	],
	"./solid/cloud-sun-rain.svg": [
		24564,
		24564
	],
	"./solid/cloud-sun.svg": [
		30658,
		30658
	],
	"./solid/cloud-upload-alt.svg": [
		79553,
		79553
	],
	"./solid/cloud.svg": [
		35802,
		35802
	],
	"./solid/cocktail.svg": [
		36144,
		36144
	],
	"./solid/code-branch.svg": [
		4295,
		4295
	],
	"./solid/code.svg": [
		77759,
		77759
	],
	"./solid/coffee.svg": [
		46076,
		46076
	],
	"./solid/cog.svg": [
		44642,
		44642
	],
	"./solid/cogs.svg": [
		30411,
		30411
	],
	"./solid/coins.svg": [
		72103,
		72103
	],
	"./solid/columns.svg": [
		13033,
		13033
	],
	"./solid/comment-alt.svg": [
		36658,
		36658
	],
	"./solid/comment-dollar.svg": [
		3661,
		3661
	],
	"./solid/comment-dots.svg": [
		31019,
		31019
	],
	"./solid/comment-medical.svg": [
		79898,
		79898
	],
	"./solid/comment-slash.svg": [
		81059,
		81059
	],
	"./solid/comment.svg": [
		92602,
		92602
	],
	"./solid/comments-dollar.svg": [
		18690,
		18690
	],
	"./solid/comments.svg": [
		49650,
		49650
	],
	"./solid/compact-disc.svg": [
		48755,
		48755
	],
	"./solid/compass.svg": [
		968,
		968
	],
	"./solid/compress-alt.svg": [
		52122,
		52122
	],
	"./solid/compress-arrows-alt.svg": [
		75655,
		75655
	],
	"./solid/compress.svg": [
		40387,
		40387
	],
	"./solid/concierge-bell.svg": [
		46430,
		46430
	],
	"./solid/cookie-bite.svg": [
		34509,
		34509
	],
	"./solid/cookie.svg": [
		66084,
		66084
	],
	"./solid/copy.svg": [
		70686,
		70686
	],
	"./solid/copyright.svg": [
		31527,
		31527
	],
	"./solid/couch.svg": [
		17543,
		17543
	],
	"./solid/credit-card.svg": [
		21482,
		21482
	],
	"./solid/crop-alt.svg": [
		53388,
		53388
	],
	"./solid/crop.svg": [
		31084,
		31084
	],
	"./solid/cross.svg": [
		40007,
		40007
	],
	"./solid/crosshairs.svg": [
		52839,
		52839
	],
	"./solid/crow.svg": [
		58330,
		58330
	],
	"./solid/crown.svg": [
		70977,
		70977
	],
	"./solid/crutch.svg": [
		46055,
		46055
	],
	"./solid/cube.svg": [
		82747,
		82747
	],
	"./solid/cubes.svg": [
		98322,
		98322
	],
	"./solid/cut.svg": [
		68523,
		68523
	],
	"./solid/database.svg": [
		1509,
		1509
	],
	"./solid/deaf.svg": [
		17691,
		17691
	],
	"./solid/democrat.svg": [
		11088,
		11088
	],
	"./solid/desktop.svg": [
		19877,
		19877
	],
	"./solid/dharmachakra.svg": [
		33231,
		33231
	],
	"./solid/diagnoses.svg": [
		84648,
		84648
	],
	"./solid/dice-d20.svg": [
		42905,
		42905
	],
	"./solid/dice-d6.svg": [
		99888,
		99888
	],
	"./solid/dice-five.svg": [
		80794,
		80794
	],
	"./solid/dice-four.svg": [
		70222,
		70222
	],
	"./solid/dice-one.svg": [
		64753,
		64753
	],
	"./solid/dice-six.svg": [
		17483,
		17483
	],
	"./solid/dice-three.svg": [
		65841,
		65841
	],
	"./solid/dice-two.svg": [
		86835,
		86835
	],
	"./solid/dice.svg": [
		18938,
		18938
	],
	"./solid/digital-tachograph.svg": [
		71873,
		71873
	],
	"./solid/directions.svg": [
		61099,
		61099
	],
	"./solid/disease.svg": [
		43152,
		43152
	],
	"./solid/divide.svg": [
		71655,
		71655
	],
	"./solid/dizzy.svg": [
		75816,
		75816
	],
	"./solid/dna.svg": [
		5340,
		5340
	],
	"./solid/dog.svg": [
		11969,
		11969
	],
	"./solid/dollar-sign.svg": [
		25707,
		25707
	],
	"./solid/dolly-flatbed.svg": [
		59541,
		59541
	],
	"./solid/dolly.svg": [
		30912,
		30912
	],
	"./solid/donate.svg": [
		93514,
		93514
	],
	"./solid/door-closed.svg": [
		94353,
		94353
	],
	"./solid/door-open.svg": [
		71612,
		71612
	],
	"./solid/dot-circle.svg": [
		96739,
		96739
	],
	"./solid/dove.svg": [
		34794,
		34794
	],
	"./solid/download.svg": [
		25262,
		25262
	],
	"./solid/drafting-compass.svg": [
		38718,
		38718
	],
	"./solid/dragon.svg": [
		31602,
		31602
	],
	"./solid/draw-polygon.svg": [
		41649,
		41649
	],
	"./solid/drum-steelpan.svg": [
		7498,
		7498
	],
	"./solid/drum.svg": [
		2096,
		2096
	],
	"./solid/drumstick-bite.svg": [
		63328,
		63328
	],
	"./solid/dumbbell.svg": [
		54634,
		54634
	],
	"./solid/dumpster-fire.svg": [
		58713,
		58713
	],
	"./solid/dumpster.svg": [
		81684,
		81684
	],
	"./solid/dungeon.svg": [
		8932,
		8932
	],
	"./solid/edit.svg": [
		56257,
		56257
	],
	"./solid/egg.svg": [
		52948,
		52948
	],
	"./solid/eject.svg": [
		10964,
		10964
	],
	"./solid/ellipsis-h.svg": [
		4034,
		4034
	],
	"./solid/ellipsis-v.svg": [
		98739,
		15403
	],
	"./solid/envelope-open-text.svg": [
		61306,
		61306
	],
	"./solid/envelope-open.svg": [
		96986,
		96986
	],
	"./solid/envelope-square.svg": [
		7587,
		7587
	],
	"./solid/envelope.svg": [
		97414,
		97414
	],
	"./solid/equals.svg": [
		67434,
		67434
	],
	"./solid/eraser.svg": [
		49127,
		49127
	],
	"./solid/ethernet.svg": [
		94190,
		94190
	],
	"./solid/euro-sign.svg": [
		97323,
		97323
	],
	"./solid/exchange-alt.svg": [
		3564,
		3564
	],
	"./solid/exclamation-circle.svg": [
		6374,
		6374
	],
	"./solid/exclamation-triangle.svg": [
		96951,
		96951
	],
	"./solid/exclamation.svg": [
		67598,
		67598
	],
	"./solid/expand-alt.svg": [
		45679,
		45679
	],
	"./solid/expand-arrows-alt.svg": [
		20980,
		20980
	],
	"./solid/expand.svg": [
		81057,
		81057
	],
	"./solid/external-link-alt.svg": [
		47480,
		47480
	],
	"./solid/external-link-square-alt.svg": [
		70908,
		70908
	],
	"./solid/eye-dropper.svg": [
		65082,
		65082
	],
	"./solid/eye-slash.svg": [
		74970,
		74970
	],
	"./solid/eye.svg": [
		2787,
		2787
	],
	"./solid/fan.svg": [
		53714,
		53714
	],
	"./solid/fast-backward.svg": [
		8450,
		8450
	],
	"./solid/fast-forward.svg": [
		79848,
		79848
	],
	"./solid/faucet.svg": [
		74080,
		74080
	],
	"./solid/fax.svg": [
		10633,
		10633
	],
	"./solid/feather-alt.svg": [
		36992,
		36992
	],
	"./solid/feather.svg": [
		41415,
		41415
	],
	"./solid/female.svg": [
		59930,
		59930
	],
	"./solid/fighter-jet.svg": [
		20117,
		20117
	],
	"./solid/file-alt.svg": [
		2072,
		2072
	],
	"./solid/file-archive.svg": [
		53842,
		53842
	],
	"./solid/file-audio.svg": [
		89518,
		89518
	],
	"./solid/file-code.svg": [
		4420,
		4420
	],
	"./solid/file-contract.svg": [
		21737,
		21737
	],
	"./solid/file-csv.svg": [
		91797,
		91797
	],
	"./solid/file-download.svg": [
		38188,
		38188
	],
	"./solid/file-excel.svg": [
		34923,
		34923
	],
	"./solid/file-export.svg": [
		2217,
		2217
	],
	"./solid/file-image.svg": [
		13152,
		13152
	],
	"./solid/file-import.svg": [
		18491,
		18491
	],
	"./solid/file-invoice-dollar.svg": [
		6218,
		6218
	],
	"./solid/file-invoice.svg": [
		31059,
		31059
	],
	"./solid/file-medical-alt.svg": [
		88553,
		88553
	],
	"./solid/file-medical.svg": [
		36645,
		36645
	],
	"./solid/file-pdf.svg": [
		6802,
		6802
	],
	"./solid/file-powerpoint.svg": [
		68143,
		68143
	],
	"./solid/file-prescription.svg": [
		40951,
		40951
	],
	"./solid/file-signature.svg": [
		85068,
		85068
	],
	"./solid/file-upload.svg": [
		31203,
		31203
	],
	"./solid/file-video.svg": [
		26364,
		26364
	],
	"./solid/file-word.svg": [
		45402,
		45402
	],
	"./solid/file.svg": [
		97673,
		97673
	],
	"./solid/fill-drip.svg": [
		51738,
		51738
	],
	"./solid/fill.svg": [
		17282,
		17282
	],
	"./solid/film.svg": [
		7970,
		7970
	],
	"./solid/filter.svg": [
		65845,
		65714
	],
	"./solid/fingerprint.svg": [
		83602,
		83602
	],
	"./solid/fire-alt.svg": [
		92611,
		92611
	],
	"./solid/fire-extinguisher.svg": [
		24779,
		24779
	],
	"./solid/fire.svg": [
		97136,
		97136
	],
	"./solid/first-aid.svg": [
		99980,
		99980
	],
	"./solid/fish.svg": [
		65975,
		65975
	],
	"./solid/fist-raised.svg": [
		4016,
		4016
	],
	"./solid/flag-checkered.svg": [
		40398,
		40398
	],
	"./solid/flag-usa.svg": [
		17395,
		17395
	],
	"./solid/flag.svg": [
		61841,
		61841
	],
	"./solid/flask.svg": [
		52923,
		52923
	],
	"./solid/flushed.svg": [
		33559,
		33559
	],
	"./solid/folder-minus.svg": [
		40729,
		40729
	],
	"./solid/folder-open.svg": [
		63509,
		63509
	],
	"./solid/folder-plus.svg": [
		19255,
		19255
	],
	"./solid/folder.svg": [
		54780,
		54780
	],
	"./solid/font-awesome-logo-full.svg": [
		74237,
		24667
	],
	"./solid/font.svg": [
		85910,
		85910
	],
	"./solid/football-ball.svg": [
		58718,
		58718
	],
	"./solid/forward.svg": [
		28038,
		28038
	],
	"./solid/frog.svg": [
		43365,
		43365
	],
	"./solid/frown-open.svg": [
		62224,
		62224
	],
	"./solid/frown.svg": [
		66441,
		66441
	],
	"./solid/funnel-dollar.svg": [
		78957,
		78957
	],
	"./solid/futbol.svg": [
		18166,
		18166
	],
	"./solid/gamepad.svg": [
		1979,
		1979
	],
	"./solid/gas-pump.svg": [
		22452,
		22452
	],
	"./solid/gavel.svg": [
		79122,
		79122
	],
	"./solid/gem.svg": [
		94111,
		94111
	],
	"./solid/genderless.svg": [
		89996,
		89996
	],
	"./solid/ghost.svg": [
		56816,
		56816
	],
	"./solid/gift.svg": [
		9473,
		9473
	],
	"./solid/gifts.svg": [
		15661,
		72749
	],
	"./solid/glass-cheers.svg": [
		39495,
		39495
	],
	"./solid/glass-martini-alt.svg": [
		24496,
		24496
	],
	"./solid/glass-martini.svg": [
		94961,
		94961
	],
	"./solid/glass-whiskey.svg": [
		1837,
		1837
	],
	"./solid/glasses.svg": [
		55148,
		55148
	],
	"./solid/globe-africa.svg": [
		24789,
		24789
	],
	"./solid/globe-americas.svg": [
		89413,
		89413
	],
	"./solid/globe-asia.svg": [
		41234,
		41234
	],
	"./solid/globe-europe.svg": [
		26821,
		26821
	],
	"./solid/globe.svg": [
		92065,
		92065
	],
	"./solid/golf-ball.svg": [
		63770,
		63770
	],
	"./solid/gopuram.svg": [
		90233,
		90233
	],
	"./solid/graduation-cap.svg": [
		71447,
		71447
	],
	"./solid/greater-than-equal.svg": [
		67506,
		67506
	],
	"./solid/greater-than.svg": [
		60063,
		60063
	],
	"./solid/grimace.svg": [
		85588,
		85588
	],
	"./solid/grin-alt.svg": [
		47989,
		47989
	],
	"./solid/grin-beam-sweat.svg": [
		12888,
		12888
	],
	"./solid/grin-beam.svg": [
		41712,
		41712
	],
	"./solid/grin-hearts.svg": [
		31128,
		31128
	],
	"./solid/grin-squint-tears.svg": [
		55480,
		55480
	],
	"./solid/grin-squint.svg": [
		5583,
		5583
	],
	"./solid/grin-stars.svg": [
		3991,
		3991
	],
	"./solid/grin-tears.svg": [
		79408,
		79408
	],
	"./solid/grin-tongue-squint.svg": [
		73627,
		96815
	],
	"./solid/grin-tongue-wink.svg": [
		19664,
		19664
	],
	"./solid/grin-tongue.svg": [
		25508,
		25508
	],
	"./solid/grin-wink.svg": [
		71661,
		71661
	],
	"./solid/grin.svg": [
		6352,
		6352
	],
	"./solid/grip-horizontal.svg": [
		19092,
		19092
	],
	"./solid/grip-lines-vertical.svg": [
		75088,
		75088
	],
	"./solid/grip-lines.svg": [
		69431,
		69431
	],
	"./solid/grip-vertical.svg": [
		89658,
		89658
	],
	"./solid/guitar.svg": [
		53390,
		53390
	],
	"./solid/h-square.svg": [
		93626,
		93626
	],
	"./solid/hamburger.svg": [
		74473,
		74473
	],
	"./solid/hammer.svg": [
		41088,
		41088
	],
	"./solid/hamsa.svg": [
		59875,
		59875
	],
	"./solid/hand-holding-heart.svg": [
		56402,
		56402
	],
	"./solid/hand-holding-medical.svg": [
		48335,
		48335
	],
	"./solid/hand-holding-usd.svg": [
		72774,
		72774
	],
	"./solid/hand-holding-water.svg": [
		82194,
		82194
	],
	"./solid/hand-holding.svg": [
		27042,
		27042
	],
	"./solid/hand-lizard.svg": [
		55544,
		55544
	],
	"./solid/hand-middle-finger.svg": [
		14477,
		14477
	],
	"./solid/hand-paper.svg": [
		99750,
		99750
	],
	"./solid/hand-peace.svg": [
		65740,
		65740
	],
	"./solid/hand-point-down.svg": [
		46715,
		46715
	],
	"./solid/hand-point-left.svg": [
		15567,
		15567
	],
	"./solid/hand-point-right.svg": [
		51966,
		51966
	],
	"./solid/hand-point-up.svg": [
		64404,
		64404
	],
	"./solid/hand-pointer.svg": [
		42353,
		42353
	],
	"./solid/hand-rock.svg": [
		6578,
		6578
	],
	"./solid/hand-scissors.svg": [
		85934,
		85934
	],
	"./solid/hand-sparkles.svg": [
		93976,
		93976
	],
	"./solid/hand-spock.svg": [
		98848,
		98848
	],
	"./solid/hands-helping.svg": [
		35859,
		35859
	],
	"./solid/hands-wash.svg": [
		72696,
		72696
	],
	"./solid/hands.svg": [
		66806,
		66806
	],
	"./solid/handshake-alt-slash.svg": [
		85705,
		85705
	],
	"./solid/handshake-slash.svg": [
		67076,
		67076
	],
	"./solid/handshake.svg": [
		33139,
		33139
	],
	"./solid/hanukiah.svg": [
		57534,
		57534
	],
	"./solid/hard-hat.svg": [
		41728,
		41728
	],
	"./solid/hashtag.svg": [
		44936,
		44936
	],
	"./solid/hat-cowboy-side.svg": [
		98709,
		98709
	],
	"./solid/hat-cowboy.svg": [
		30002,
		30002
	],
	"./solid/hat-wizard.svg": [
		77946,
		77946
	],
	"./solid/hdd.svg": [
		16109,
		16109
	],
	"./solid/head-side-cough-slash.svg": [
		47211,
		47211
	],
	"./solid/head-side-cough.svg": [
		53047,
		43670
	],
	"./solid/head-side-mask.svg": [
		41975,
		41975
	],
	"./solid/head-side-virus.svg": [
		75373,
		75373
	],
	"./solid/heading.svg": [
		40828,
		40828
	],
	"./solid/headphones-alt.svg": [
		63608,
		63608
	],
	"./solid/headphones.svg": [
		40562,
		40562
	],
	"./solid/headset.svg": [
		17418,
		17418
	],
	"./solid/heart-broken.svg": [
		75992,
		75992
	],
	"./solid/heart.svg": [
		40116,
		40116
	],
	"./solid/heartbeat.svg": [
		53227,
		53227
	],
	"./solid/helicopter.svg": [
		7690,
		7690
	],
	"./solid/highlighter.svg": [
		30608,
		30608
	],
	"./solid/hiking.svg": [
		56079,
		56079
	],
	"./solid/hippo.svg": [
		13865,
		13865
	],
	"./solid/history.svg": [
		32233,
		32233
	],
	"./solid/hockey-puck.svg": [
		55016,
		55016
	],
	"./solid/holly-berry.svg": [
		11882,
		11882
	],
	"./solid/home.svg": [
		68542,
		68542
	],
	"./solid/horse-head.svg": [
		52821,
		52821
	],
	"./solid/horse.svg": [
		44991,
		44991
	],
	"./solid/hospital-alt.svg": [
		12437,
		12437
	],
	"./solid/hospital-symbol.svg": [
		293,
		293
	],
	"./solid/hospital-user.svg": [
		51439,
		51439
	],
	"./solid/hospital.svg": [
		20456,
		20456
	],
	"./solid/hot-tub.svg": [
		16248,
		16248
	],
	"./solid/hotdog.svg": [
		11338,
		11338
	],
	"./solid/hotel.svg": [
		44188,
		44188
	],
	"./solid/hourglass-end.svg": [
		10547,
		21581
	],
	"./solid/hourglass-half.svg": [
		60620,
		60620
	],
	"./solid/hourglass-start.svg": [
		46342,
		46342
	],
	"./solid/hourglass.svg": [
		21893,
		21893
	],
	"./solid/house-damage.svg": [
		12684,
		12684
	],
	"./solid/house-user.svg": [
		84136,
		84136
	],
	"./solid/hryvnia.svg": [
		53236,
		53236
	],
	"./solid/i-cursor.svg": [
		54370,
		54370
	],
	"./solid/ice-cream.svg": [
		52956,
		52956
	],
	"./solid/icicles.svg": [
		41801,
		41801
	],
	"./solid/icons.svg": [
		74334,
		74334
	],
	"./solid/id-badge.svg": [
		19889,
		19889
	],
	"./solid/id-card-alt.svg": [
		32667,
		32667
	],
	"./solid/id-card.svg": [
		64681,
		64681
	],
	"./solid/igloo.svg": [
		27780,
		27780
	],
	"./solid/image.svg": [
		42781,
		42781
	],
	"./solid/images.svg": [
		50019,
		50019
	],
	"./solid/inbox.svg": [
		89649,
		89649
	],
	"./solid/indent.svg": [
		78713,
		78713
	],
	"./solid/industry.svg": [
		43061,
		43061
	],
	"./solid/infinity.svg": [
		40739,
		40739
	],
	"./solid/info-circle.svg": [
		34580,
		34580
	],
	"./solid/info.svg": [
		23747,
		23747
	],
	"./solid/italic.svg": [
		53315,
		53315
	],
	"./solid/jedi.svg": [
		82879,
		82879
	],
	"./solid/joint.svg": [
		10026,
		10026
	],
	"./solid/journal-whills.svg": [
		82061,
		82061
	],
	"./solid/kaaba.svg": [
		85837,
		85837
	],
	"./solid/key.svg": [
		2660,
		2660
	],
	"./solid/keyboard.svg": [
		86326,
		86326
	],
	"./solid/khanda.svg": [
		55543,
		55543
	],
	"./solid/kiss-beam.svg": [
		30445,
		30445
	],
	"./solid/kiss-wink-heart.svg": [
		68877,
		68877
	],
	"./solid/kiss.svg": [
		24625,
		24625
	],
	"./solid/kiwi-bird.svg": [
		79729,
		79729
	],
	"./solid/landmark.svg": [
		73740,
		73740
	],
	"./solid/language.svg": [
		26560,
		26560
	],
	"./solid/laptop-code.svg": [
		73016,
		73016
	],
	"./solid/laptop-house.svg": [
		67655,
		67655
	],
	"./solid/laptop-medical.svg": [
		16728,
		16728
	],
	"./solid/laptop.svg": [
		84597,
		84597
	],
	"./solid/laugh-beam.svg": [
		2449,
		2449
	],
	"./solid/laugh-squint.svg": [
		89759,
		89759
	],
	"./solid/laugh-wink.svg": [
		7064,
		7064
	],
	"./solid/laugh.svg": [
		72576,
		72576
	],
	"./solid/layer-group.svg": [
		38814,
		38814
	],
	"./solid/leaf.svg": [
		18424,
		18424
	],
	"./solid/lemon.svg": [
		92668,
		92668
	],
	"./solid/less-than-equal.svg": [
		41636,
		41636
	],
	"./solid/less-than.svg": [
		88909,
		88909
	],
	"./solid/level-down-alt.svg": [
		63709,
		63709
	],
	"./solid/level-up-alt.svg": [
		57286,
		57286
	],
	"./solid/life-ring.svg": [
		36460,
		36460
	],
	"./solid/lightbulb.svg": [
		35035,
		35035
	],
	"./solid/link.svg": [
		84865,
		84865
	],
	"./solid/lira-sign.svg": [
		9547,
		9547
	],
	"./solid/list-alt.svg": [
		75409,
		75409
	],
	"./solid/list-ol.svg": [
		83242,
		83242
	],
	"./solid/list-ul.svg": [
		51368,
		51368
	],
	"./solid/list.svg": [
		38176,
		38176
	],
	"./solid/location-arrow.svg": [
		11478,
		79598
	],
	"./solid/lock-open.svg": [
		51181,
		51181
	],
	"./solid/lock.svg": [
		87462,
		87462
	],
	"./solid/long-arrow-alt-down.svg": [
		30307,
		30307
	],
	"./solid/long-arrow-alt-left.svg": [
		50373,
		50373
	],
	"./solid/long-arrow-alt-right.svg": [
		15326,
		15326
	],
	"./solid/long-arrow-alt-up.svg": [
		17272,
		17272
	],
	"./solid/low-vision.svg": [
		40941,
		40941
	],
	"./solid/luggage-cart.svg": [
		43524,
		43524
	],
	"./solid/lungs-virus.svg": [
		33252,
		33252
	],
	"./solid/lungs.svg": [
		57354,
		57354
	],
	"./solid/magic.svg": [
		31144,
		31144
	],
	"./solid/magnet.svg": [
		8612,
		8612
	],
	"./solid/mail-bulk.svg": [
		1203,
		1203
	],
	"./solid/male.svg": [
		69090,
		69090
	],
	"./solid/map-marked-alt.svg": [
		65310,
		65310
	],
	"./solid/map-marked.svg": [
		10558,
		10558
	],
	"./solid/map-marker-alt.svg": [
		25010,
		25010
	],
	"./solid/map-marker.svg": [
		68154,
		68154
	],
	"./solid/map-pin.svg": [
		67012,
		67012
	],
	"./solid/map-signs.svg": [
		63271,
		63271
	],
	"./solid/map.svg": [
		70796,
		70796
	],
	"./solid/marker.svg": [
		35970,
		35970
	],
	"./solid/mars-double.svg": [
		35509,
		35509
	],
	"./solid/mars-stroke-h.svg": [
		1581,
		1581
	],
	"./solid/mars-stroke-v.svg": [
		59907,
		59907
	],
	"./solid/mars-stroke.svg": [
		8137,
		8137
	],
	"./solid/mars.svg": [
		14618,
		14618
	],
	"./solid/mask.svg": [
		50987,
		50987
	],
	"./solid/medal.svg": [
		33493,
		33493
	],
	"./solid/medkit.svg": [
		52019,
		52019
	],
	"./solid/meh-blank.svg": [
		45327,
		45327
	],
	"./solid/meh-rolling-eyes.svg": [
		2883,
		2883
	],
	"./solid/meh.svg": [
		18873,
		18873
	],
	"./solid/memory.svg": [
		4437,
		4437
	],
	"./solid/menorah.svg": [
		7795,
		7795
	],
	"./solid/mercury.svg": [
		82603,
		82603
	],
	"./solid/meteor.svg": [
		23125,
		23125
	],
	"./solid/microchip.svg": [
		69753,
		69753
	],
	"./solid/microphone-alt-slash.svg": [
		69286,
		69286
	],
	"./solid/microphone-alt.svg": [
		83323,
		83323
	],
	"./solid/microphone-slash.svg": [
		61774,
		61774
	],
	"./solid/microphone.svg": [
		66476,
		66476
	],
	"./solid/microscope.svg": [
		28301,
		28301
	],
	"./solid/minus-circle.svg": [
		1609,
		1609
	],
	"./solid/minus-square.svg": [
		99670,
		99670
	],
	"./solid/minus.svg": [
		45121,
		45121
	],
	"./solid/mitten.svg": [
		58725,
		58725
	],
	"./solid/mobile-alt.svg": [
		9363,
		9363
	],
	"./solid/mobile.svg": [
		87466,
		87466
	],
	"./solid/money-bill-alt.svg": [
		94232,
		94232
	],
	"./solid/money-bill-wave-alt.svg": [
		21531,
		21531
	],
	"./solid/money-bill-wave.svg": [
		45277,
		45277
	],
	"./solid/money-bill.svg": [
		32793,
		32793
	],
	"./solid/money-check-alt.svg": [
		97390,
		97390
	],
	"./solid/money-check.svg": [
		26507,
		26507
	],
	"./solid/monument.svg": [
		30078,
		30078
	],
	"./solid/moon.svg": [
		77585,
		77585
	],
	"./solid/mortar-pestle.svg": [
		68121,
		68121
	],
	"./solid/mosque.svg": [
		2470,
		2470
	],
	"./solid/motorcycle.svg": [
		88373,
		88373
	],
	"./solid/mountain.svg": [
		98567,
		98567
	],
	"./solid/mouse-pointer.svg": [
		21530,
		21530
	],
	"./solid/mouse.svg": [
		84902,
		84902
	],
	"./solid/mug-hot.svg": [
		85644,
		85644
	],
	"./solid/music.svg": [
		17232,
		17232
	],
	"./solid/network-wired.svg": [
		13760,
		13760
	],
	"./solid/neuter.svg": [
		22674,
		22674
	],
	"./solid/newspaper.svg": [
		85835,
		85835
	],
	"./solid/not-equal.svg": [
		38794,
		38794
	],
	"./solid/notes-medical.svg": [
		12002,
		12002
	],
	"./solid/object-group.svg": [
		38212,
		38212
	],
	"./solid/object-ungroup.svg": [
		85335,
		85335
	],
	"./solid/oil-can.svg": [
		54027,
		54027
	],
	"./solid/om.svg": [
		27075,
		27075
	],
	"./solid/otter.svg": [
		28227,
		28227
	],
	"./solid/outdent.svg": [
		57393,
		57393
	],
	"./solid/pager.svg": [
		63082,
		95289
	],
	"./solid/paint-brush.svg": [
		21357,
		21357
	],
	"./solid/paint-roller.svg": [
		31163,
		31163
	],
	"./solid/palette.svg": [
		9176,
		9176
	],
	"./solid/pallet.svg": [
		46374,
		46374
	],
	"./solid/paper-plane.svg": [
		32118,
		32118
	],
	"./solid/paperclip.svg": [
		90957,
		90957
	],
	"./solid/parachute-box.svg": [
		71410,
		71410
	],
	"./solid/paragraph.svg": [
		53576,
		53576
	],
	"./solid/parking.svg": [
		303,
		303
	],
	"./solid/passport.svg": [
		10400,
		10400
	],
	"./solid/pastafarianism.svg": [
		62106,
		62106
	],
	"./solid/paste.svg": [
		58225,
		58225
	],
	"./solid/pause-circle.svg": [
		54527,
		54527
	],
	"./solid/pause.svg": [
		12276,
		12276
	],
	"./solid/paw.svg": [
		11575,
		11575
	],
	"./solid/peace.svg": [
		59687,
		59687
	],
	"./solid/pen-alt.svg": [
		1426,
		1426
	],
	"./solid/pen-fancy.svg": [
		87345,
		87345
	],
	"./solid/pen-nib.svg": [
		98431,
		98431
	],
	"./solid/pen-square.svg": [
		82671,
		82671
	],
	"./solid/pen.svg": [
		68511,
		68511
	],
	"./solid/pencil-alt.svg": [
		91893,
		91893
	],
	"./solid/pencil-ruler.svg": [
		6438,
		6438
	],
	"./solid/people-arrows.svg": [
		3743,
		3743
	],
	"./solid/people-carry.svg": [
		89898,
		89898
	],
	"./solid/pepper-hot.svg": [
		24684,
		24684
	],
	"./solid/percent.svg": [
		34338,
		34338
	],
	"./solid/percentage.svg": [
		4679,
		4679
	],
	"./solid/person-booth.svg": [
		19479,
		19479
	],
	"./solid/phone-alt.svg": [
		4129,
		4129
	],
	"./solid/phone-slash.svg": [
		41318,
		41318
	],
	"./solid/phone-square-alt.svg": [
		85308,
		85308
	],
	"./solid/phone-square.svg": [
		30323,
		30323
	],
	"./solid/phone-volume.svg": [
		63019,
		63019
	],
	"./solid/phone.svg": [
		82477,
		82477
	],
	"./solid/photo-video.svg": [
		83579,
		83579
	],
	"./solid/piggy-bank.svg": [
		36412,
		36412
	],
	"./solid/pills.svg": [
		21505,
		21505
	],
	"./solid/pizza-slice.svg": [
		2022,
		2022
	],
	"./solid/place-of-worship.svg": [
		12836,
		12836
	],
	"./solid/plane-arrival.svg": [
		77943,
		77943
	],
	"./solid/plane-departure.svg": [
		77836,
		77836
	],
	"./solid/plane-slash.svg": [
		65067,
		65067
	],
	"./solid/plane.svg": [
		40614,
		40614
	],
	"./solid/play-circle.svg": [
		71339,
		71339
	],
	"./solid/play.svg": [
		18722,
		18722
	],
	"./solid/plug.svg": [
		48633,
		48633
	],
	"./solid/plus-circle.svg": [
		33216,
		33216
	],
	"./solid/plus-square.svg": [
		26085,
		26085
	],
	"./solid/plus.svg": [
		77738,
		77738
	],
	"./solid/podcast.svg": [
		5278,
		5278
	],
	"./solid/poll-h.svg": [
		76865,
		76865
	],
	"./solid/poll.svg": [
		68593,
		68593
	],
	"./solid/poo-storm.svg": [
		9647,
		9647
	],
	"./solid/poo.svg": [
		87587,
		87587
	],
	"./solid/poop.svg": [
		92443,
		92443
	],
	"./solid/portrait.svg": [
		15256,
		15256
	],
	"./solid/pound-sign.svg": [
		39071,
		39071
	],
	"./solid/power-off.svg": [
		56650,
		56650
	],
	"./solid/pray.svg": [
		94156,
		94156
	],
	"./solid/praying-hands.svg": [
		27450,
		27450
	],
	"./solid/prescription-bottle-alt.svg": [
		92980,
		92980
	],
	"./solid/prescription-bottle.svg": [
		16932,
		16932
	],
	"./solid/prescription.svg": [
		41011,
		41011
	],
	"./solid/print.svg": [
		9068,
		9068
	],
	"./solid/procedures.svg": [
		1017,
		1017
	],
	"./solid/project-diagram.svg": [
		64106,
		64106
	],
	"./solid/pump-medical.svg": [
		73612,
		73612
	],
	"./solid/pump-soap.svg": [
		41179,
		41179
	],
	"./solid/puzzle-piece.svg": [
		72314,
		72314
	],
	"./solid/qrcode.svg": [
		82740,
		82740
	],
	"./solid/question-circle.svg": [
		38906,
		38906
	],
	"./solid/question.svg": [
		80221,
		80221
	],
	"./solid/quidditch.svg": [
		72414,
		72414
	],
	"./solid/quote-left.svg": [
		23275,
		23275
	],
	"./solid/quote-right.svg": [
		72846,
		72846
	],
	"./solid/quran.svg": [
		41985,
		41985
	],
	"./solid/radiation-alt.svg": [
		38767,
		38767
	],
	"./solid/radiation.svg": [
		21758,
		21758
	],
	"./solid/rainbow.svg": [
		68264,
		68264
	],
	"./solid/random.svg": [
		24354,
		24354
	],
	"./solid/receipt.svg": [
		81540,
		81540
	],
	"./solid/record-vinyl.svg": [
		31127,
		31127
	],
	"./solid/recycle.svg": [
		40853,
		40853
	],
	"./solid/redo-alt.svg": [
		39118,
		39118
	],
	"./solid/redo.svg": [
		37675,
		37675
	],
	"./solid/registered.svg": [
		33682,
		33682
	],
	"./solid/remove-format.svg": [
		6909,
		6909
	],
	"./solid/reply-all.svg": [
		7009,
		7009
	],
	"./solid/reply.svg": [
		58833,
		58833
	],
	"./solid/republican.svg": [
		97700,
		97700
	],
	"./solid/restroom.svg": [
		93850,
		93850
	],
	"./solid/retweet.svg": [
		71190,
		71190
	],
	"./solid/ribbon.svg": [
		46388,
		46388
	],
	"./solid/ring.svg": [
		49647,
		49647
	],
	"./solid/road.svg": [
		78472,
		78472
	],
	"./solid/robot.svg": [
		15999,
		15999
	],
	"./solid/rocket.svg": [
		32061,
		32061
	],
	"./solid/route.svg": [
		19884,
		19884
	],
	"./solid/rss-square.svg": [
		6962,
		6962
	],
	"./solid/rss.svg": [
		74211,
		74211
	],
	"./solid/ruble-sign.svg": [
		39392,
		39392
	],
	"./solid/ruler-combined.svg": [
		66949,
		66949
	],
	"./solid/ruler-horizontal.svg": [
		17233,
		17233
	],
	"./solid/ruler-vertical.svg": [
		73783,
		73783
	],
	"./solid/ruler.svg": [
		1449,
		1449
	],
	"./solid/running.svg": [
		34595,
		34595
	],
	"./solid/rupee-sign.svg": [
		41731,
		41731
	],
	"./solid/sad-cry.svg": [
		21779,
		21779
	],
	"./solid/sad-tear.svg": [
		60294,
		60294
	],
	"./solid/satellite-dish.svg": [
		8056,
		8056
	],
	"./solid/satellite.svg": [
		69506,
		69506
	],
	"./solid/save.svg": [
		45946,
		45946
	],
	"./solid/school.svg": [
		38943,
		38943
	],
	"./solid/screwdriver.svg": [
		17065,
		17065
	],
	"./solid/scroll.svg": [
		61070,
		61070
	],
	"./solid/sd-card.svg": [
		27285,
		27285
	],
	"./solid/search-dollar.svg": [
		93461,
		93461
	],
	"./solid/search-location.svg": [
		52492,
		52492
	],
	"./solid/search-minus.svg": [
		88584,
		88584
	],
	"./solid/search-plus.svg": [
		47762,
		47762
	],
	"./solid/search.svg": [
		54228,
		54228
	],
	"./solid/seedling.svg": [
		94385,
		94385
	],
	"./solid/server.svg": [
		90807,
		90807
	],
	"./solid/shapes.svg": [
		83187,
		83187
	],
	"./solid/share-alt-square.svg": [
		41453,
		41453
	],
	"./solid/share-alt.svg": [
		60518,
		60518
	],
	"./solid/share-square.svg": [
		70483,
		70483
	],
	"./solid/share.svg": [
		94727,
		94727
	],
	"./solid/shekel-sign.svg": [
		53036,
		53036
	],
	"./solid/shield-alt.svg": [
		59257,
		59257
	],
	"./solid/shield-virus.svg": [
		97887,
		97887
	],
	"./solid/ship.svg": [
		31411,
		31411
	],
	"./solid/shipping-fast.svg": [
		98945,
		98945
	],
	"./solid/shoe-prints.svg": [
		88314,
		88314
	],
	"./solid/shopping-bag.svg": [
		43639,
		43639
	],
	"./solid/shopping-basket.svg": [
		19207,
		74237
	],
	"./solid/shopping-cart.svg": [
		76467,
		76467
	],
	"./solid/shower.svg": [
		26868,
		26868
	],
	"./solid/shuttle-van.svg": [
		45847,
		45847
	],
	"./solid/sign-in-alt.svg": [
		60736,
		60736
	],
	"./solid/sign-language.svg": [
		86039,
		86039
	],
	"./solid/sign-out-alt.svg": [
		50621,
		50621
	],
	"./solid/sign.svg": [
		10097,
		10097
	],
	"./solid/signal.svg": [
		39950,
		39950
	],
	"./solid/signature.svg": [
		93262,
		93262
	],
	"./solid/sim-card.svg": [
		74582,
		74582
	],
	"./solid/sink.svg": [
		86004,
		86004
	],
	"./solid/sitemap.svg": [
		26252,
		26252
	],
	"./solid/skating.svg": [
		16740,
		16740
	],
	"./solid/skiing-nordic.svg": [
		85032,
		85032
	],
	"./solid/skiing.svg": [
		19876,
		19876
	],
	"./solid/skull-crossbones.svg": [
		95914,
		95914
	],
	"./solid/skull.svg": [
		80906,
		80906
	],
	"./solid/slash.svg": [
		44327,
		44327
	],
	"./solid/sleigh.svg": [
		77656,
		77656
	],
	"./solid/sliders-h.svg": [
		56748,
		56748
	],
	"./solid/smile-beam.svg": [
		22299,
		22299
	],
	"./solid/smile-wink.svg": [
		98027,
		98027
	],
	"./solid/smile.svg": [
		36608,
		36608
	],
	"./solid/smog.svg": [
		12112,
		12112
	],
	"./solid/smoking-ban.svg": [
		59883,
		59883
	],
	"./solid/smoking.svg": [
		18278,
		18278
	],
	"./solid/sms.svg": [
		22685,
		22685
	],
	"./solid/snowboarding.svg": [
		42367,
		42367
	],
	"./solid/snowflake.svg": [
		57582,
		57582
	],
	"./solid/snowman.svg": [
		1959,
		1959
	],
	"./solid/snowplow.svg": [
		85599,
		85599
	],
	"./solid/soap.svg": [
		60836,
		60836
	],
	"./solid/socks.svg": [
		99274,
		99274
	],
	"./solid/solar-panel.svg": [
		39342,
		39342
	],
	"./solid/sort-alpha-down-alt.svg": [
		44053,
		44053
	],
	"./solid/sort-alpha-down.svg": [
		28425,
		28425
	],
	"./solid/sort-alpha-up-alt.svg": [
		989,
		989
	],
	"./solid/sort-alpha-up.svg": [
		8410,
		8410
	],
	"./solid/sort-amount-down-alt.svg": [
		58812,
		58812
	],
	"./solid/sort-amount-down.svg": [
		4969,
		4969
	],
	"./solid/sort-amount-up-alt.svg": [
		23473,
		23473
	],
	"./solid/sort-amount-up.svg": [
		60282,
		60282
	],
	"./solid/sort-down.svg": [
		55941,
		55941
	],
	"./solid/sort-numeric-down-alt.svg": [
		94761,
		94761
	],
	"./solid/sort-numeric-down.svg": [
		28138,
		28138
	],
	"./solid/sort-numeric-up-alt.svg": [
		15058,
		15058
	],
	"./solid/sort-numeric-up.svg": [
		89417,
		89417
	],
	"./solid/sort-up.svg": [
		39473,
		39473
	],
	"./solid/sort.svg": [
		58052,
		58052
	],
	"./solid/spa.svg": [
		62454,
		62454
	],
	"./solid/space-shuttle.svg": [
		84303,
		84303
	],
	"./solid/spell-check.svg": [
		18969,
		18969
	],
	"./solid/spider.svg": [
		29211,
		29211
	],
	"./solid/spinner.svg": [
		50933,
		50933
	],
	"./solid/splotch.svg": [
		46082,
		46082
	],
	"./solid/spray-can.svg": [
		30115,
		30115
	],
	"./solid/square-full.svg": [
		68206,
		68206
	],
	"./solid/square-root-alt.svg": [
		59265,
		59265
	],
	"./solid/square.svg": [
		15626,
		15626
	],
	"./solid/stamp.svg": [
		11750,
		11750
	],
	"./solid/star-and-crescent.svg": [
		13848,
		13848
	],
	"./solid/star-half-alt.svg": [
		22621,
		22621
	],
	"./solid/star-half.svg": [
		48626,
		48626
	],
	"./solid/star-of-david.svg": [
		58484,
		58484
	],
	"./solid/star-of-life.svg": [
		72113,
		72113
	],
	"./solid/star.svg": [
		76184,
		76184
	],
	"./solid/step-backward.svg": [
		88715,
		88715
	],
	"./solid/step-forward.svg": [
		8639,
		8639
	],
	"./solid/stethoscope.svg": [
		1489,
		1489
	],
	"./solid/sticky-note.svg": [
		22919,
		22919
	],
	"./solid/stop-circle.svg": [
		19138,
		19138
	],
	"./solid/stop.svg": [
		53872,
		53872
	],
	"./solid/stopwatch-20.svg": [
		68921,
		68921
	],
	"./solid/stopwatch.svg": [
		85932,
		85932
	],
	"./solid/store-alt-slash.svg": [
		64790,
		64790
	],
	"./solid/store-alt.svg": [
		64578,
		64578
	],
	"./solid/store-slash.svg": [
		65503,
		65503
	],
	"./solid/store.svg": [
		64374,
		64374
	],
	"./solid/stream.svg": [
		41550,
		41550
	],
	"./solid/street-view.svg": [
		73356,
		73356
	],
	"./solid/strikethrough.svg": [
		55564,
		55564
	],
	"./solid/stroopwafel.svg": [
		20309,
		20309
	],
	"./solid/subscript.svg": [
		3577,
		3577
	],
	"./solid/subway.svg": [
		13840,
		13840
	],
	"./solid/suitcase-rolling.svg": [
		73091,
		73091
	],
	"./solid/suitcase.svg": [
		16410,
		16410
	],
	"./solid/sun.svg": [
		20276,
		20276
	],
	"./solid/superscript.svg": [
		60,
		98555
	],
	"./solid/surprise.svg": [
		6073,
		6073
	],
	"./solid/swatchbook.svg": [
		85647,
		85647
	],
	"./solid/swimmer.svg": [
		81509,
		28909
	],
	"./solid/swimming-pool.svg": [
		61855,
		61855
	],
	"./solid/synagogue.svg": [
		26616,
		26616
	],
	"./solid/sync-alt.svg": [
		12479,
		12479
	],
	"./solid/sync.svg": [
		78223,
		78223
	],
	"./solid/syringe.svg": [
		73489,
		73489
	],
	"./solid/table-tennis.svg": [
		21145,
		21145
	],
	"./solid/table.svg": [
		572,
		572
	],
	"./solid/tablet-alt.svg": [
		95201,
		95201
	],
	"./solid/tablet.svg": [
		59430,
		59430
	],
	"./solid/tablets.svg": [
		9218,
		9218
	],
	"./solid/tachometer-alt.svg": [
		31135,
		31135
	],
	"./solid/tag.svg": [
		5531,
		5531
	],
	"./solid/tags.svg": [
		65087,
		65087
	],
	"./solid/tape.svg": [
		51956,
		51956
	],
	"./solid/tasks.svg": [
		92315,
		92315
	],
	"./solid/taxi.svg": [
		97704,
		97704
	],
	"./solid/teeth-open.svg": [
		67994,
		67994
	],
	"./solid/teeth.svg": [
		75692,
		75692
	],
	"./solid/temperature-high.svg": [
		48852,
		48852
	],
	"./solid/temperature-low.svg": [
		56679,
		56679
	],
	"./solid/tenge.svg": [
		69228,
		69228
	],
	"./solid/terminal.svg": [
		1077,
		1077
	],
	"./solid/text-height.svg": [
		7258,
		7258
	],
	"./solid/text-width.svg": [
		79870,
		79870
	],
	"./solid/th-large.svg": [
		20236,
		20236
	],
	"./solid/th-list.svg": [
		58213,
		58213
	],
	"./solid/th.svg": [
		78827,
		78827
	],
	"./solid/theater-masks.svg": [
		22986,
		22986
	],
	"./solid/thermometer-empty.svg": [
		89174,
		89174
	],
	"./solid/thermometer-full.svg": [
		48618,
		48618
	],
	"./solid/thermometer-half.svg": [
		93610,
		93610
	],
	"./solid/thermometer-quarter.svg": [
		88706,
		88706
	],
	"./solid/thermometer-three-quarters.svg": [
		6673,
		6673
	],
	"./solid/thermometer.svg": [
		36596,
		36596
	],
	"./solid/thumbs-down.svg": [
		2141,
		2141
	],
	"./solid/thumbs-up.svg": [
		35888,
		35888
	],
	"./solid/thumbtack.svg": [
		24630,
		24630
	],
	"./solid/ticket-alt.svg": [
		37257,
		37257
	],
	"./solid/times-circle.svg": [
		55291,
		55291
	],
	"./solid/times.svg": [
		49115,
		49115
	],
	"./solid/tint-slash.svg": [
		90139,
		90139
	],
	"./solid/tint.svg": [
		65367,
		65367
	],
	"./solid/tired.svg": [
		78776,
		89465
	],
	"./solid/toggle-off.svg": [
		40565,
		40565
	],
	"./solid/toggle-on.svg": [
		61823,
		61823
	],
	"./solid/toilet-paper-slash.svg": [
		56944,
		56944
	],
	"./solid/toilet-paper.svg": [
		51088,
		51088
	],
	"./solid/toilet.svg": [
		99449,
		99449
	],
	"./solid/toolbox.svg": [
		80929,
		80929
	],
	"./solid/tools.svg": [
		18361,
		18361
	],
	"./solid/tooth.svg": [
		26881,
		26881
	],
	"./solid/torah.svg": [
		64300,
		64300
	],
	"./solid/torii-gate.svg": [
		18486,
		18486
	],
	"./solid/tractor.svg": [
		74805,
		74805
	],
	"./solid/trademark.svg": [
		78583,
		78583
	],
	"./solid/traffic-light.svg": [
		77863,
		77863
	],
	"./solid/trailer.svg": [
		90741,
		90741
	],
	"./solid/train.svg": [
		72235,
		72235
	],
	"./solid/tram.svg": [
		64172,
		64172
	],
	"./solid/transgender-alt.svg": [
		60638,
		60638
	],
	"./solid/transgender.svg": [
		80516,
		80516
	],
	"./solid/trash-alt.svg": [
		73878,
		73878
	],
	"./solid/trash-restore-alt.svg": [
		50377,
		50377
	],
	"./solid/trash-restore.svg": [
		46709,
		46709
	],
	"./solid/trash.svg": [
		6630,
		6630
	],
	"./solid/tree.svg": [
		18981,
		18981
	],
	"./solid/trophy.svg": [
		66187,
		66187
	],
	"./solid/truck-loading.svg": [
		54458,
		54458
	],
	"./solid/truck-monster.svg": [
		4384,
		4384
	],
	"./solid/truck-moving.svg": [
		31040,
		31040
	],
	"./solid/truck-pickup.svg": [
		57837,
		57837
	],
	"./solid/truck.svg": [
		56690,
		56690
	],
	"./solid/tshirt.svg": [
		32577,
		32577
	],
	"./solid/tty.svg": [
		8529,
		8529
	],
	"./solid/tv.svg": [
		28835,
		28835
	],
	"./solid/umbrella-beach.svg": [
		75371,
		75371
	],
	"./solid/umbrella.svg": [
		80666,
		80666
	],
	"./solid/underline.svg": [
		94077,
		94077
	],
	"./solid/undo-alt.svg": [
		60044,
		60044
	],
	"./solid/undo.svg": [
		60709,
		60709
	],
	"./solid/universal-access.svg": [
		67954,
		67954
	],
	"./solid/university.svg": [
		12793,
		12793
	],
	"./solid/unlink.svg": [
		78893,
		78893
	],
	"./solid/unlock-alt.svg": [
		58782,
		58782
	],
	"./solid/unlock.svg": [
		55037,
		55037
	],
	"./solid/upload.svg": [
		31255,
		31255
	],
	"./solid/user-alt-slash.svg": [
		98969,
		98969
	],
	"./solid/user-alt.svg": [
		69158,
		69158
	],
	"./solid/user-astronaut.svg": [
		57238,
		57238
	],
	"./solid/user-check.svg": [
		69629,
		69629
	],
	"./solid/user-circle.svg": [
		8379,
		8379
	],
	"./solid/user-clock.svg": [
		25972,
		25972
	],
	"./solid/user-cog.svg": [
		14765,
		14765
	],
	"./solid/user-edit.svg": [
		34446,
		34446
	],
	"./solid/user-friends.svg": [
		17434,
		17434
	],
	"./solid/user-graduate.svg": [
		4802,
		4802
	],
	"./solid/user-injured.svg": [
		70684,
		70684
	],
	"./solid/user-lock.svg": [
		59158,
		59158
	],
	"./solid/user-md.svg": [
		59943,
		59943
	],
	"./solid/user-minus.svg": [
		23514,
		23514
	],
	"./solid/user-ninja.svg": [
		88220,
		34469
	],
	"./solid/user-nurse.svg": [
		68698,
		68698
	],
	"./solid/user-plus.svg": [
		97232,
		97232
	],
	"./solid/user-secret.svg": [
		68839,
		68839
	],
	"./solid/user-shield.svg": [
		32494,
		32494
	],
	"./solid/user-slash.svg": [
		57927,
		57927
	],
	"./solid/user-tag.svg": [
		56451,
		56451
	],
	"./solid/user-tie.svg": [
		97560,
		97560
	],
	"./solid/user-times.svg": [
		93607,
		84404
	],
	"./solid/user.svg": [
		87987,
		87987
	],
	"./solid/users-cog.svg": [
		57466,
		57466
	],
	"./solid/users-slash.svg": [
		39297,
		39297
	],
	"./solid/users.svg": [
		71729,
		71729
	],
	"./solid/utensil-spoon.svg": [
		23988,
		23988
	],
	"./solid/utensils.svg": [
		58490,
		58490
	],
	"./solid/vector-square.svg": [
		13494,
		13494
	],
	"./solid/venus-double.svg": [
		16175,
		16175
	],
	"./solid/venus-mars.svg": [
		90609,
		90609
	],
	"./solid/venus.svg": [
		40558,
		40558
	],
	"./solid/vest-patches.svg": [
		55228,
		55228
	],
	"./solid/vest.svg": [
		13894,
		13894
	],
	"./solid/vial.svg": [
		99024,
		99024
	],
	"./solid/vials.svg": [
		26004,
		26004
	],
	"./solid/video-slash.svg": [
		76804,
		76804
	],
	"./solid/video.svg": [
		774,
		774
	],
	"./solid/vihara.svg": [
		88581,
		88581
	],
	"./solid/virus-slash.svg": [
		48361,
		48361
	],
	"./solid/virus.svg": [
		25923,
		25923
	],
	"./solid/viruses.svg": [
		97844,
		97844
	],
	"./solid/voicemail.svg": [
		78508,
		78508
	],
	"./solid/volleyball-ball.svg": [
		9082,
		9082
	],
	"./solid/volume-down.svg": [
		31961,
		31961
	],
	"./solid/volume-mute.svg": [
		82560,
		82560
	],
	"./solid/volume-off.svg": [
		44452,
		44452
	],
	"./solid/volume-up.svg": [
		53811,
		53811
	],
	"./solid/vote-yea.svg": [
		36281,
		36281
	],
	"./solid/vr-cardboard.svg": [
		82488,
		82488
	],
	"./solid/walking.svg": [
		9679,
		9679
	],
	"./solid/wallet.svg": [
		7160,
		7160
	],
	"./solid/warehouse.svg": [
		1348,
		1348
	],
	"./solid/water.svg": [
		24810,
		24810
	],
	"./solid/wave-square.svg": [
		31778,
		31778
	],
	"./solid/weight-hanging.svg": [
		15306,
		15306
	],
	"./solid/weight.svg": [
		98589,
		98589
	],
	"./solid/wheelchair.svg": [
		25839,
		25839
	],
	"./solid/wifi.svg": [
		4811,
		4811
	],
	"./solid/wind.svg": [
		39309,
		39309
	],
	"./solid/window-close.svg": [
		59873,
		88220
	],
	"./solid/window-maximize.svg": [
		31011,
		31011
	],
	"./solid/window-minimize.svg": [
		6404,
		6404
	],
	"./solid/window-restore.svg": [
		21587,
		21587
	],
	"./solid/wine-bottle.svg": [
		69329,
		69329
	],
	"./solid/wine-glass-alt.svg": [
		32027,
		32027
	],
	"./solid/wine-glass.svg": [
		84482,
		84482
	],
	"./solid/won-sign.svg": [
		34152,
		34152
	],
	"./solid/wrench.svg": [
		26781,
		26781
	],
	"./solid/x-ray.svg": [
		94104,
		94104
	],
	"./solid/yen-sign.svg": [
		10900,
		10900
	],
	"./solid/yin-yang.svg": [
		15877,
		15877
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17146;
module.exports = webpackAsyncContext;